import { MS_TO_MICRO, SEC_TO_MS } from "./cfg/const"
import { 
  SERVICES_HOSTNAME, 
  REQUEST_TEXT_SUMMARY_ENDPOINT, SIGNIN_USER_ENDPOINT, SIGNUP_USER_ENDPOINT, 
  SUBMIT_TRACKER, SETTINGS, REQUEST_EMAIL_ENDPOINT, 
  SESSION_REVIEW, COMMENTS, REQUEST_GEN_COACHING_ENDPOINT, 
  GET_USER, PROSPECT_INFO_CHOICES, DISPOSITION_CHOICES, 
  AUDIO_LINKS,
  METRIC_DETAILS_V6, SESSION_LIST_V5,
  GET_TEAM,
  AREA_CODE_CONNECT_RATE,
  OAUTHLOGIN_TYPES,
  REQUEST_CUSTOM_SCORE,
  TEAM_BOTS, GLOBAL_BOTS, PROSPECT_BOTS, BOT_EMOTIONS, BOT_GENERATOR, BOT_CALL, BOT_CALLS, BOT_CALL_ANALYSIS,
  GLOBAL_BOT_SKILLS, TEAM_BOT_SKILLS, BOT_SKILL_GENERATOR,
  CUSTOM_DEFINITIONS, REQUEST_CUSTOM_METRIC,
  EMAIL_VALUE_PROP, REQUEST_PROSPECT_EMAIL_GEN, REQUEST_PROSPECT_EMAIL_GEN_REVISION,
  REQUEST_PROSPECT_LINKEDIN_GEN, REQUEST_PROSPECT_LINKEDIN_REVISION,
  TWILIO_NUMBERS, SNIPPETS, LINKEDIN_VOICE_MEMOS,
  GOOGLE_EXCHANGE_CODE, GOOGLE_GET_CURRENT_TOKEN,
  SERVICES_WEATHER, REVIEW_COUNTS, AUGMENTATION_HOSTNAME,
  SCOPES_V2, GET_ADMIN_WRITE_TARGETS, GET_VISIBLE_ACCOUNTS,
  USER_GROUP, USER_GROUP_MEMBERSHIP, CONDITIONS, PLAYS,
  PASSWORD_RESET_REQUEST, PASSWORD_RESET, AUTODIALER_SETTINGS, AUTODIALER_MAPPING_OPTIONS,
  AUTODIALER_MAPPINGS,
  USER_ADMIN, TEAM_ADMIN, SCOPE_ADMIN, DOMAIN_ADMIN, SEATS, TEAM_INVITATIONS, TEAM_MEMBERS, TWILIO_NUMBERS_ADMIN,
  SHAKEN_STIR, VOICE_INTEGRITY, CNAM, AI_MANY_CALL_ANALYSIS_V2,
  MULTIDIALER_SETTINGS, RECORDED_GREETINGS, SALES_FLOOR_HOSTNAME, SALES_FLOOR_ROOMS, SALES_FLOOR_ROOM_MEMBERS,
  GET_SESSION_DATA_V4, API_CONTACT, API_PERSON,
  API_SEARCH_NAME,
  REQUEST_AGENT_SUMMARY,
  LEADERBOARD_AVATAR,
  LEADERBOARD_MEMBERSHIP,
  LEADERBOARD_ROOM,
  LEADERBOARD_DATA,
  ROUTER_HOSTNAME,
  RT_ROUTER_ENSURE_SESSION_USER_MESSAGE,
  MULTIDIALER_ADMIN_V2,
  SAVED_VIEWS,
  MULTIDIALER_ADMIN,
  API_PROVISIONED_TEAMS,
  API_INBOUND_ROUTES,
  API_MEGA_COMPOSERS,
  API_SPLIT_COMPOSERS,
  API_VOICE_BOTS,
  API_CHAT_BOTS,
  API_SESSION_WEBHOOKS,
  API_STATE_FIELDS,
  ALL_AUTODIALER_SETTINGS,
  ALL_AUTODIALER_MAPPINGS,
  INTERVIEW_PORTAL_LINKS,
  INTERVIEW_PORTAL_LINK_INFO,
  INTERVIEW_PORTAL_BOTS,
  INTERVIEW_BOT_CALLS,
  INTERVIEW_BOT_CALL,
  INTERVIEW_BOT_CALLS_ADMIN,
  INTERVIEW_PORTAL_USERS,
} from "./cfg/endpoints"
import { TRACKER_TYPE } from "./cfg/sources"
import { corsGet, corsPut, corsDelete, simplePost, responseToJson, simpleFetchAndCheck } from "./network"
import { logInfo, sleep } from "./core"
import { AuthorizationInfo, getApiKeyInfo } from "./components/Authentication/utils"

// Import required types
import { jsonSafeToSummarizerResult, TextSummaryResult } from "interfaces/ai-automations"
import { AuthResult, TrackerPayloadParam } from "interfaces/auth"
import { ReviewCount, jsonSafeToReviewCounts } from "interfaces/metrics"
import { MetricResult } from "interfaces/metrics"
import { BotSessionQueryParams } from "interfaces/bots"
import { MultiDialerQuotaInfo, ParallelDialerQuotasUpdate, ParallelDialerAccessInfo, jsonSafeToParallelDialerAccessInfo, jsonSafeToQuotaInfo } from "interfaces/subscriptions"
import { EmailGenRequest, CustomEditInfo, LinkedInGenRequest } from "interfaces/ai-automations"
import { AdminUserSettingsUpdate, AdminTeamSettingUpdate } from "interfaces/admin"
import { cleanTemporalFilterDisjunctions, jsonSafeToCondition, jsonSafeToConditionResult, jsonSafeToPlay, jsonSafeToPlayResult } from "interfaces/plays"
import { TemporalFilterDisjunction } from "interfaces/plays"
import { Condition, Play } from "interfaces/plays"
import { DEFAULT_LANGUAGE_SETTING, GetUserGroupResult, PROSPECT_RECORDING_SETTING, SubscriptionType } from "interfaces/users"
import { ProspectInfoChoices } from "interfaces/metadata"
import { SummarizerResult } from "interfaces/ai-automations"
import {
  WeatherData, RoomMetricType, GetRoomMembershipsResult, RoomMetadata, jsonSafeToWeatherData,
  jsonSafeToLeaderboardDataResult,
  LeaderboardDataResult,
  GLOBAL_ROOM_ID,
  GLOBAL_ROOM_NAME,
} from "interfaces/coaching"
import { SettingsResult, SettingsUpdate, ScopeV2Result, AdminWriteTargetsResult, ScopeV2 } from "interfaces/users"
// Removed duplicate import - see line 127 for combined import
import {
  UserDataResult, TeamResult, UserAndUserAuthResult, VisibleAccountsResult,
  // JSON safe conversion functions from services interfaces
  jsonSafeToAuthorizedUserDataResult, jsonSafeToTeamResult, jsonSafeToVisibleAccountsResult, jsonSafeToUserAndUserAuthResults,
  jsonSafeToTeamResults
} from "interfaces/users"
import {
  AudioDataResult,
  CommentDataResult, CommentParams,
  jsonSafeToAudioDataResult,
  jsonSafeToComment,
  jsonSafeToSessionDataResponse,
  UpdateType
} from "interfaces/sessions"
import { AreaCodeConnectRateResult } from "interfaces/metrics"
import { MetricDetailResultV6, MetricDetailParamsV6 } from "interfaces/metrics"
import { SessionDataResult, SessionListResponse, SessionListV5Params, jsonSafeToSessionListResponse } from "interfaces/sessions"
import { 
  PersonV2, ContactV2, Bot, BotEmotion, BotGeneration, BotCall, BotCallTranscript, 
  CallDifficultyMode, CallBotEmotion, BotSkill, CustomDefinition, 
  EmailValueProp, AIProspectEmail, LinkedInGeneratedMessage, 
  RegisteredTwilioNumber, SessionV2, Snippet, LinkedInVoiceMemoMetadata,
  UserGroup, 
  AIManyCallAnalysis,
  RecordedGreeting, SalesRoom, OptionalTwilioNumber, TeamInvitation,
  AGENT_TYPE,
  // JSON safe conversion functions from db interfaces
  jsonSafeToRegisteredTwilioNumbers,
  jsonSafeToAIProspectEmail, jsonSafeToLinkedInGeneratedEmail,
  jsonSafeToBots,
  jsonSafeToCustomDefinitions, jsonSafeToSnippets,
  jsonSafeToSnippet, jsonSafeToSessionV2,
  jsonSafeToMultiAICallAnalysis,
  jsonSafeToBotCall,
  jsonSafeToBotCalls,
  jsonSafeToBot,
  jsonSafeToTeamInvitation,
  PartyRole
} from "interfaces/db"
import { AutoDialerMappingOptions, AutoDialerMapping, jsonSafeToAutodialerMappingOptionsList, SETTING } from "interfaces/settings"
import { CustomerProfileData, VoiceIntegrityInfo, VoiceIntegrityUseCase, CNAMRegistration, jsonSafeToCustomerProfileData, jsonSafeToCNAMRegistration } from "./interfaces/twilio"
import { GoogleTokenConfig } from "components/GoogleSheets/cfg"
import { Call } from "@vapi-ai/server-sdk/api"
import { AvatarStyle } from "./components/Leaderboard"
import { VapiClient } from "@vapi-ai/server-sdk"
import { jsonSafeToSavedView, jsonSafeToSavedViewList, SavedView } from "interfaces/views"
import { BackendFilter } from "interfaces/sessions"
import { jsonSafeToProvisionedTeams, ProvisionedTeam } from "interfaces/provisioned"
import { InboundRoute, MegaPromptComposer, jsonToMegaPromptComposer, VoiceBot, ChatBot, jsonToVoiceBot, jsonToChatBots, jsonToVoiceBots, jsonToMegaPromptComposers, SplitComposer, SplitComposersResponse, jsonToSplitComposers, jsonToSplitGoals, jsonToSplitComposer } from "interfaces/bot-config"
import { 
  StateCollection, 
  StateFieldsResponse, 
  SessionWebhooksResponse, 
  CreateStateCollectionRequest,
  UpdateStateCollectionRequest,
  StateField,
  SessionWebhookRegistry,
  SessionWebhookPayload
} from "interfaces/payloads"
import { jsonSafeToAutodialerSettings } from "interfaces/settings"
import { AutoDialerSetting } from "interfaces/settings"
import { SelectionType, UserSelection } from "interfaces/settings"
import { 
  InterviewPortalInfo, 
  InterviewBotCall, 
  InterviewBot, 
  InterviewPortalUser,
  CreateInterviewBotCallRequest, 
  CreateInterviewBotCallResponse,
  CreateInterviewPortalRequest,
  UpdateInterviewPortalRequest,
  jsonSafeToInterviewPortalInfo,
  jsonSafeToInterviewBotCall,
  jsonSafeToInterviewBotCalls,
  jsonSafeToInterviewPortalUser,
  jsonSafeToInterviewBots 
} from "interfaces/interview"

// ==================== CACHE DURATION CONSTANTS ====================

const CACHE_30_SECONDS = 30 * 1000
const CACHE_5_MINUTES = 5 * 60 * 1000
const CACHE_10_MINUTES = 10 * 60 * 1000

// ==================== STANDARDIZED SERVICE ARCHITECTURE ====================

interface ServiceConfig {
  cacheable?: boolean
  cacheTimeMs?: number
}

interface CacheEntry<T> {
  data: T
  timestamp: number
  expiryMs: number
}

class ServiceCache {
  private cache = new Map<string, CacheEntry<any>>()

  get<T>(key: string): T | null {
    const entry = this.cache.get(key)
    if (!entry) return null
    
    if (Date.now() - entry.timestamp > entry.expiryMs) {
      this.cache.delete(key)
      return null
    }
    
    return entry.data
  }

  set<T>(key: string, data: T, expiryMs: number): void {
    this.cache.set(key, {
      data,
      timestamp: Date.now(),
      expiryMs
    })
  }

  clear(pattern?: string): void {
    if (!pattern) {
      this.cache.clear()
      return
    }
    
    for (const key of this.cache.keys()) {
      if (key.includes(pattern)) {
        this.cache.delete(key)
      }
    }
  }
}

const serviceCache = new ServiceCache()

// Standard HTTP methods with optional caching and JSON conversion
async function standardGet<T>(
  url: string, 
  params: Record<string, any>, 
  config: ServiceConfig = {},
  converter?: (data: any) => T
): Promise<T | null> {
  const cacheKey = config.cacheable ? `GET:${url}:${JSON.stringify(params)}` : null
  
  if (cacheKey) {
    const cached = serviceCache.get<T>(cacheKey)
    if (cached) return cached
  }

  try {
    const result = await corsGet(url, params)
    let data: T
    
    // Apply converter function if provided, otherwise use result as-is
    if (converter) {
      data = converter(result)
    } else {
      data = result as T
    }
    
    if (cacheKey && config.cacheTimeMs) {
      serviceCache.set(cacheKey, data, config.cacheTimeMs)
    }
    
    return data
  } catch (e) {
    logInfo(`[Services] GET ${url} failed:`, e)
    return null
  }
}

async function standardPost<T>(
  url: string, 
  params: Record<string, any>, 
  options: { textResponse?: boolean, noJsonification?: boolean } = {},
  converter?: (data: any) => T
): Promise<T | null> {
  try {
    const result = await simplePost(url, params, options.textResponse, options.noJsonification)
    if (converter) return converter(result)
    return result as T
  } catch (e) {
    logInfo(`[Services] POST ${url} failed:`, e)
    return null
  }
}

// Result type with consistent structure
type ServiceResult<T> = {
  success: boolean
  value: T | null
  error_message: string | null
}

// New version that explicitly returns success/error wrapper
async function standardPostWithErrorHandling<T>(
  url: string, 
  params: Record<string, any>, 
  options: { textResponse?: boolean, noJsonification?: boolean } = {},
  converter?: (data: any) => T
): Promise<ServiceResult<T>> {
  try {
    // Use simpleFetchAndCheck instead of simplePost to properly handle HTTP errors
    const result = await simpleFetchAndCheck(url, params, true, options.noJsonification)
    
    if (options.noJsonification) {
      const data = converter ? converter(result) : (result as T)
      return { success: true, value: data, error_message: null }
    }
    
    // For text responses or JSON responses, result should already be processed
    const data = converter ? converter(result) : (result as T)
    return { success: true, value: data, error_message: null }
  } catch (e) {
    console.log(`[Services] standardPostWithErrorHandling caught error:`, e); // Debug log
    logInfo(`[Services] POST ${url} with error handling failed:`, e)
    
    // simpleFetchAndCheck throws Error with the response text as the message
    const errorMessage = e instanceof Error ? e.message : 'Request failed'
    console.log(`[Services] Extracted error message:`, errorMessage); // Debug log
    return { success: false, value: null, error_message: errorMessage || 'Bad Request - please check your input and try again' }
  }
}

async function standardPut<T>(
  url: string, 
  params: Record<string, any>,
  options: { statusOnly?: boolean, rawResponse?: boolean } = {},
  converter?: (data: any) => T| Promise<T>
): Promise<T | null> {
  try {
    const result = await corsPut(url, params)
    if (options.rawResponse) {
      if (converter) return await converter(result)
      return result as unknown as T
    }
    if (options.statusOnly) {
      // Explicitly cast boolean to T to handle type checking
      return (result.status === 200) as unknown as T
    }
    if (result.status === 200) {
      const data = await responseToJson(result)
      if (converter) return await converter(data)
      return data as T
    }
    return null
  } catch (e) {
    logInfo(`[Services] PUT ${url} failed:`, e)
    return null
  }
}

async function standardDelete<T>(
  url: string, 
  params: Record<string, any>
): Promise<T | null> {
  try {
    const result = await corsDelete(url, params)
    if (result.status === 200) {
      const data = await responseToJson(result)
      return data as T
    }
    return null
  } catch (e) {
    logInfo(`[Services] DELETE ${url} failed:`, e)
    return null
  }
}


// Helper to build URLs
function buildUrl(hostname: string, endpoint: string): string {
  return `https://${hostname}/${endpoint}`
}

// ==================== SIMPLIFIED SERVICE FUNCTIONS ====================

export class ServicesManager {
  apiKey: string | null = null
  hostname: string = SERVICES_HOSTNAME
  selectedTeamId: string | null = null
  hasInitialized: boolean = false

  updateApiInfo(info: AuthorizationInfo) {
    this.apiKey = info.apiKey
    this.hostname = info.services ?? SERVICES_HOSTNAME
    this.hasInitialized = true
  }

  async fetchApiKey() {
    const info = await getApiKeyInfo()
    if (info) {
      this.apiKey = info.apiKey
      this.hostname = info.services ?? SERVICES_HOSTNAME
    }
    this.hasInitialized = true
  }

  // ==================== TEAM SELECTION MANAGEMENT ====================
  
  updateSelectedTeamId(teamId: string) {
    this.selectedTeamId = teamId;
  }

  clearSelectedTeamId() {
    this.selectedTeamId = null;
  }

  constructor() {
    this.hasInitialized = false;
    this.fetchApiKey();
    // No longer initialize from localStorage - Redux will manage this
  }

  async getApiKey(): Promise<string | null> {
    while (!this.hasInitialized) {
      if (this.apiKey != null) return this.apiKey
      await sleep(0.5 * 1000) // SEC_TO_MS
    }
    return this.apiKey ?? null
  }

  // ==================== API KEY WRAPPER ====================
  
  /**
   * Wrapper function to handle API key fetching and validation for all service methods
   * Eliminates the repetitive getApiKey/null check pattern
   */
  private async withApiKey<T>(
    operation: (apiKey: string) => Promise<T>
  ): Promise<T | null> {
    const apiKey = await this.getApiKey()
    if (!apiKey) return null
    try {
      return await operation(apiKey)
    } catch (e) {
      logInfo(`[Services] failed:`, e)
      return null
    }
  }

  private async withApiKeyServiceResult<T>(
    operation: (apiKey: string) => Promise<ServiceResult<T>>
  ): Promise<ServiceResult<T>> {
    const apiKey = await this.getApiKey()
    if (!apiKey) {
      return { success: false, value: null, error_message: 'No API key available' }
    }
    try {
      return await operation(apiKey)
    } catch (e) {
      logInfo(`[Services] failed:`, e)
      const errorMessage = e instanceof Error ? e.message : 'Unknown error occurred'
      return { success: false, value: null, error_message: errorMessage }
    }
  }
    
  // ==================== USER & TEAM ====================
  
  async getUser(): Promise<UserDataResult | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<UserDataResult>(
      buildUrl(this.hostname, GET_USER),
      { api_key: apiKey },
      { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
      jsonSafeToAuthorizedUserDataResult
    )
    })
  }

  async getTeam(): Promise<TeamResult | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<TeamResult>(
      buildUrl(this.hostname, GET_TEAM),
      { api_key: apiKey },
      { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
      jsonSafeToTeamResult
    )
    })
  }

  // ==================== SESSIONS ====================
  
  async getListUserSessionsV5(
    listUserSessionParams: SessionListV5Params,
  ): Promise<SessionListResponse[] | null> {
    return this.withApiKey(async (apiKey) => {
    const config = { cacheable: true, cacheTimeMs: CACHE_30_SECONDS }
    const sessionListConverter = (result: any) => jsonSafeToSessionListResponse(result, listUserSessionParams.select)
    const params: Record<string, any> = {
      api_key: apiKey,
      cnf: listUserSessionParams.cnf,
      select: listUserSessionParams.select
    }
    
    // Add optional date parameters
    if (listUserSessionParams.start) {
      params.start = listUserSessionParams.start.getTime() * MS_TO_MICRO
    }
    if (listUserSessionParams.end) {
      params.end = listUserSessionParams.end.getTime() * MS_TO_MICRO
    }

    // Add read_team_id if a team is selected
    if (this.selectedTeamId) {
      params['team_id'] = this.selectedTeamId
    } 

    return standardGet<SessionListResponse[]>(
      buildUrl(this.hostname, SESSION_LIST_V5),
      params,
      config,
      sessionListConverter
    )
    })
  }

  async getSessionData(sessionId: string): Promise<SessionDataResult | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<SessionDataResult>(
      buildUrl(this.hostname, GET_SESSION_DATA_V4),
      { api_key: apiKey, session_id: sessionId },
      { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
      jsonSafeToSessionDataResponse
    )
    })
  }

  async getAudioData(sessionId: string): Promise<AudioDataResult | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<AudioDataResult>(
      buildUrl(this.hostname, AUDIO_LINKS),
      { api_key: apiKey, session_id: sessionId },
      { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
      jsonSafeToAudioDataResult
    )
    })
  }

  async updateSessionReview(sessionId: string, isOpen: boolean): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
    const result = await standardPut<boolean>(
      buildUrl(this.hostname, SESSION_REVIEW),
      { api_key: apiKey, session_id: sessionId, is_open: isOpen },
      { statusOnly: true }
    )
    serviceCache.clear('sessions')
    return result
    })
  }

  // ==================== COMMENTS ====================
  
  async updateComments(sessionId: string, commentParams: CommentParams[]): Promise<(CommentDataResult | null)[] | null> {
    return this.withApiKey(async (apiKey) => {
      const parameters: Record<string, any> = {
        api_key: apiKey, 
        session_id: sessionId,
        comments: commentParams.map((value: CommentParams) => {
          const ret: Record<string, any> = {}
          const comment = value.comment
          if (value.update === UpdateType.ADD || value.update === UpdateType.MODIFY) {
            if (value.update === UpdateType.MODIFY) ret['comment_id'] = comment.commentId
            ret['comment'] = comment.comment
            if (comment.start) ret['start'] = comment.start
            if (comment.end) ret['end'] = comment.end
          } else {
            // removal
            ret['comment_id'] = value.comment.commentId
          }
          return ret
        })
      }
      return standardPut<CommentDataResult[]>(
          buildUrl(this.hostname, COMMENTS),
          parameters,
          {},
          (data: any) => data.map((value: Record<string, any>) => jsonSafeToComment(value))
        )
      }
    )
  }

  // ==================== METRICS ====================
  
  async getMetricDetailsV6(metricDetailsParams: MetricDetailParamsV6): Promise<MetricDetailResultV6 | null> {
    return this.withApiKey(async (apiKey) => {
    const params: Record<string, any> = {
      api_key: apiKey,
      ...metricDetailsParams,
      start: metricDetailsParams.start.getTime() * MS_TO_MICRO,
      end: metricDetailsParams.end.getTime() * MS_TO_MICRO
    }
    if (this.selectedTeamId) {
      params['team_id'] = this.selectedTeamId
    }
    return standardGet<MetricDetailResultV6>(
      buildUrl(this.hostname, METRIC_DETAILS_V6),
      params,
    )
    })
  }

  async getAreaCodeConnectRate(
    start: Date,
    end: Date,
  ): Promise<AreaCodeConnectRateResult[] | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<AreaCodeConnectRateResult[]>(
      buildUrl(this.hostname, AREA_CODE_CONNECT_RATE),
      { 
        api_key: apiKey, 
        start: start.getTime() * MS_TO_MICRO, 
        end: end.getTime() * MS_TO_MICRO, 
        cnf: [] 
      },
      { cacheable: true, cacheTimeMs: CACHE_5_MINUTES }
    )
    })
  }

  // ==================== AI SERVICES ====================
  
  async requestCoachingSuggestion(sessionId: string): Promise<string | null> {
    return this.withApiKey(async (apiKey) => {
    return standardPost<string>(
      buildUrl(this.hostname, REQUEST_GEN_COACHING_ENDPOINT),
      { api_key: apiKey, session_id: sessionId },
      { textResponse: true }
    )
    })
  }

  async requestTextSummary(sessionId: string): Promise<TextSummaryResult | null> {
    return this.withApiKey(async (apiKey) => {
    return standardPost<TextSummaryResult>(
      buildUrl(this.hostname, REQUEST_TEXT_SUMMARY_ENDPOINT),
      { api_key: apiKey, session_id: sessionId }
    )
    })
  }

  async requestEmail(sessionId: string): Promise<string | null> {
    return this.withApiKey(async (apiKey) => {
    return standardPost<string>(
      buildUrl(this.hostname, REQUEST_EMAIL_ENDPOINT),
      { api_key: apiKey, session_id: sessionId },
      { textResponse: true }
    )
    })
  }

  async requestCustomMetric(sessionId: string): Promise<MetricResult | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<MetricResult>(
      buildUrl(this.hostname, REQUEST_CUSTOM_SCORE),
      { api_key: apiKey, session_id: sessionId }
    )
    })
  }

  // ==================== AUTHENTICATION ====================
  
  async passwordLogin(email: string, password: string): Promise<AuthResult | null> {
    return standardPost<AuthResult>(
      buildUrl(this.hostname, SIGNIN_USER_ENDPOINT),
      { email, password }
    )
  }

  async passwordSignup(name: string, email: string, password: string): Promise<AuthResult | null> {
    return standardPost<AuthResult>(
      buildUrl(this.hostname, SIGNUP_USER_ENDPOINT),
      { name, email, password }
    )
  }

  async oauthLogin(credential: string, type: OAUTHLOGIN_TYPES): Promise<AuthResult | null> {
    const parameters: Record<string, any> = {type}
    if (type === OAUTHLOGIN_TYPES.GOOGLE_LOGIN) parameters['google_credential'] = credential
    if (type === OAUTHLOGIN_TYPES.MICROSOFT_LOGIN) parameters['microsoft_credential'] = credential
    return standardPost<AuthResult>(
      buildUrl(this.hostname, SIGNUP_USER_ENDPOINT),
      parameters
    )
  }

  // ==================== SETTINGS ====================
  
  async getSettings(): Promise<SettingsResult | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<SettingsResult>(
      buildUrl(this.hostname, SETTINGS),
      { api_key: apiKey },
      { cacheable: true, cacheTimeMs: CACHE_5_MINUTES }
    )
    })
  }

  async postSettings(update: SettingsUpdate): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
    const params: Record<string, any> = { api_key: apiKey, update }
    if (update.custom_stage_definition) {
      params.update.custom_stage_definition = JSON.stringify(update.custom_stage_definition)
    }
    
    const result = await standardPut<boolean>(buildUrl(this.hostname, SETTINGS), params, { statusOnly: true })
    serviceCache.clear('settings')
    return result
    })
  }

  // ==================== DISPOSITIONS ====================
  
  async getDispositions(): Promise<ProspectInfoChoices | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<ProspectInfoChoices>(
      buildUrl(this.hostname, DISPOSITION_CHOICES),
      { api_key: apiKey },
      { cacheable: true, cacheTimeMs: CACHE_10_MINUTES }
    )
    })
  }

  // ==================== PROSPECT INFO ====================
  
  async getProspectInfo(): Promise<ProspectInfoChoices | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<ProspectInfoChoices>(
      buildUrl(this.hostname, PROSPECT_INFO_CHOICES),
      { api_key: apiKey },
      { cacheable: true, cacheTimeMs: CACHE_10_MINUTES }
    )
    })
  }

  async getProspectsViaName(query: string): Promise<PersonV2[] | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<PersonV2[]>(
      buildUrl(this.hostname, API_SEARCH_NAME),
      { api_key: apiKey, query },
      {},
      (result: any) => {
        // The API returns { persons: PersonV2[], companies: [] }
        // We need to extract the persons array
        if (result && result.persons && Array.isArray(result.persons)) {
          return result.persons
        }
        return []
      }
    )
    })
  }

  async getContactsViaPlatformPersonIds(platformPersonIds: string[]): Promise<ContactV2[] | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<ContactV2[]>(
      buildUrl(this.hostname, API_PERSON),
      { api_key: apiKey, platform_person_ids: platformPersonIds },
      {},
      (result: any) => {
        // The API returns { person: PersonV2[], contacts: ContactV2[] }
        // We need to extract the contacts array
        if (result && result.contacts && Array.isArray(result.contacts)) {
          return result.contacts
        }
        return []
      }
    )})
  }

  async enrichContacts(addresses: string[]): Promise<ContactV2[] | null> {
    return this.withApiKey(async (apiKey) => {
    return standardGet<ContactV2[]>(
      buildUrl(this.hostname, API_CONTACT),
      { api_key: apiKey, addresses: addresses },
      {},
    )
    })
  }

  async enrichContactsToPerson(contacts: ContactV2[]): Promise<PersonV2[] | null> {
    return this.withApiKey(async (apiKey) => {
      if (!contacts || contacts.length === 0) return []
      
      // Extract platform_person_ids from contacts
      const platformPersonIds = contacts.map(c => c.platform_person_id).filter(id => id)
      if (platformPersonIds.length === 0) return []
      
      // Process in batches of 100
      const batchSize = 100
      const allResults: PersonV2[] = []
      
      for (let i = 0; i < platformPersonIds.length; i += batchSize) {
        const batch = platformPersonIds.slice(i, i + batchSize)
        
        const result = await standardGet<any>(
          buildUrl(this.hostname, API_PERSON),
          { 
            api_key: apiKey, 
            platform_person_ids: batch
          },
          {}
        )
        
        if (result && result.person) {
          // Process the person array from the result, matching old implementation
          const persons = Array.isArray(result.person) ? result.person : []
          allResults.push(...persons)
        }
      }
      
      return allResults
    })
  }

  // ==================== UTILITY FUNCTIONS ====================
  
  // Clear specific cache patterns
  clearCache(pattern?: string): void {
    serviceCache.clear(pattern)
  }

  // Force refresh for next request
  forceRefresh(endpoint: string): void {
    serviceCache.clear(endpoint)
  }

  // ==================== TRACKER SUBMISSIONS ====================
  
  async submitTrackers(
    baseUrl: string,
    trackerType: TRACKER_TYPE,
    trackerPayload?: TrackerPayloadParam,
    apiKey?: string,
  ): Promise<Record<string, any> | null> {
    // note that an api key may be passed in for this tracker since tracker submissions happen
    // sometimes right after an api key is retrieved by a user and so the extension cannot communicate it
    // to the react application in time
    if (apiKey) {
      return standardPost<any>(buildUrl(this.hostname, SUBMIT_TRACKER), { 
        api_key: apiKey, 
        base_url: baseUrl, 
        tracker_type: trackerType,
        tracker_payloads: trackerPayload
      })
    } else {
      return this.withApiKey(async (apiKey) => {
        return standardPost<any>(buildUrl(this.hostname, SUBMIT_TRACKER), { 
          api_key: apiKey, 
          base_url: baseUrl, 
          tracker_type: trackerType,
          tracker_payloads: trackerPayload
        })
      })
    }
  }

  async getScrapedSummarizedData(url: string, text: string | null, cachedOnly: boolean, agentType: AGENT_TYPE): Promise<SummarizerResult | null> {
    const apiKey = await this.getApiKey()
    if (apiKey == null) return null
    return standardPost<SummarizerResult>(
      buildUrl(AUGMENTATION_HOSTNAME, REQUEST_AGENT_SUMMARY),
      { api_key: apiKey, url, text, cached_only: cachedOnly, agent_type: agentType },
      {},
      jsonSafeToSummarizerResult
    )
  }

  // ==================== SCOPES & ADMIN ACCESS ====================
  
  async getScopes(): Promise<ScopeV2Result | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<ScopeV2Result>(
        buildUrl(this.hostname, SCOPES_V2),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES }
      )
    })
  }

  async updateScope(scope: ScopeV2, isDelete?: boolean): Promise<boolean | null> {
    const parameters: Record<string, any> = {scope} 
    if (isDelete !== undefined) parameters['delete'] = isDelete
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, SCOPES_V2),
        { api_key: apiKey, ...parameters },
        { statusOnly: true }
      )
    })
  }

  async getAdminWriteTargets(): Promise<AdminWriteTargetsResult | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<AdminWriteTargetsResult>(
        buildUrl(this.hostname, GET_ADMIN_WRITE_TARGETS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES }
      )
    })
  }

  async getVisibleAccounts(): Promise<VisibleAccountsResult | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<VisibleAccountsResult>(
        buildUrl(this.hostname, GET_VISIBLE_ACCOUNTS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonSafeToVisibleAccountsResult
      )
    })
  }

  async removeCachedSessionData(sessionId: string): Promise<void> {
    // Clear cached session data for the given session ID
    serviceCache.clear(`session:${sessionId}`)
  }

  // ==================== PROFILE & LEADERBOARD ====================

  async putProfile(avatarName: string, avatarType: AvatarStyle): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(AUGMENTATION_HOSTNAME, LEADERBOARD_AVATAR),
        { api_key: apiKey, avatar_name: avatarName, avatar_style: avatarType },
        { statusOnly: true }
      )
    })
  }

  async getUserMemberships(): Promise<GetRoomMembershipsResult | null> {
    const result = await this.withApiKey(async (apiKey) => {
      return standardGet<GetRoomMembershipsResult>(
        buildUrl(AUGMENTATION_HOSTNAME, LEADERBOARD_MEMBERSHIP),
        { api_key: apiKey },
      )
    })
    if (!result) return null
    return [...result, {'room_id': GLOBAL_ROOM_ID, 'room_name': GLOBAL_ROOM_NAME, 'metric': RoomMetricType.TOTAL_CALLS, 'team_id': null, 'email_domain': null, 'room_code': null}]
  }

  async putRoom(roomName: string, roomMetric: RoomMetricType, isTeamRoom?: boolean, isDomainRoom?: boolean, roomId?: string): Promise<RoomMetadata | null> {
    const parameters: Record<string, any> = {
      room_name: roomName, 
      room_metric: roomMetric,
    }
    if (isTeamRoom !== undefined) parameters['is_team_room'] = isTeamRoom
    if (isDomainRoom !== undefined) parameters['is_domain_room'] = isDomainRoom
    if (roomId) parameters['room_id'] = roomId
    return this.withApiKey(async (apiKey) => {
      return standardPut<RoomMetadata>(
        buildUrl(AUGMENTATION_HOSTNAME, LEADERBOARD_ROOM),
        { api_key: apiKey, ...parameters }
      )
    })
  }

  async getRoomMetadata(roomCode: string | null, roomId: string | null): Promise<RoomMetadata | null> {
    const params: Record<string, any> = {}
    if (roomCode) params['room_code'] = roomCode
    if (roomId) params['room_id'] = roomId
    return this.withApiKey(async (apiKey) => {
      return standardGet<RoomMetadata>(
        buildUrl(AUGMENTATION_HOSTNAME, LEADERBOARD_ROOM),
        { api_key: apiKey, ...params }
      )
    })
  }

  async joinRoom(roomId: string, isMember: boolean, roomCode: string | null): Promise<boolean | null> {
    const parameters: Record<string, any> = { 
      room_id: roomId,
      is_member: isMember,
    }
    if (roomCode) parameters['room_code'] = roomCode
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(AUGMENTATION_HOSTNAME, LEADERBOARD_MEMBERSHIP),
        { 
          api_key: apiKey, 
          ...parameters
        },
        { statusOnly: true }
      )
    })
  }

  async getRoomLeaderboardData(roomId: string, roomMetric: RoomMetricType): Promise<LeaderboardDataResult | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<LeaderboardDataResult>(
        buildUrl(AUGMENTATION_HOSTNAME, LEADERBOARD_DATA),
        { api_key: apiKey, room_id: roomId, room_metric: roomMetric },
        {},
        jsonSafeToLeaderboardDataResult
      )
    })
  }

  // ==================== USER GROUPS ====================
  async getUserGroups(): Promise<GetUserGroupResult | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<GetUserGroupResult>(
        buildUrl(this.hostname, USER_GROUP),
        { api_key: apiKey },
        { cacheable: false },
      )
    })
  }

  async putUserGroup(userGroupName: string | null, userGroupId: string | null, remove: boolean | null): Promise<UserGroup | boolean | null> {
    const parameters: Record<string, any> = {}
    if (userGroupName !== null) parameters['user_group_name'] = userGroupName
    if (userGroupId !== null) parameters['user_group_id'] = userGroupId
    if (remove !== null) parameters['delete'] = remove
    return this.withApiKey(async (apiKey) => {
      const response = await standardPut<Response>(
        buildUrl(this.hostname, USER_GROUP),
        { 
          api_key: apiKey,
          ...parameters
        },
        { rawResponse: true }
      )
      if (response === null) return null
      if (response.status !== 200) return false
      if (userGroupId !== null) return true
      return await response.json() as UserGroup
    })
  }

  async putUserGroupMembership(userGroupId: string, memberId: string, memberIsGroup: boolean, remove: boolean | null): Promise<boolean | null> {
    const parameters: Record<string, any> = {
      user_group_id: userGroupId,
      member_id: memberId,
      member_is_group: memberIsGroup,
    }
    if (remove !== null) parameters['delete'] = remove
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, USER_GROUP_MEMBERSHIP),
        { 
          api_key: apiKey,
          ...parameters
        },
        { statusOnly: true }
      )
    })
  }

  // ==================== CONDITIONS & PLAYS ====================
  async getConditions(): Promise<Condition[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<Condition[]>(
        buildUrl(this.hostname, CONDITIONS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonSafeToConditionResult
      )
    })
  }

  jsonifyFilterCnfStr(filterCnf: TemporalFilterDisjunction[]): string {
    const cleanedTemporal: TemporalFilterDisjunction[] = cleanTemporalFilterDisjunctions(filterCnf)
    return JSON.stringify(cleanedTemporal)
  }

  async putCondition(
    conditionId: string | null,
    filterCnf: TemporalFilterDisjunction[] | null,
    active: boolean | null,
    conditionName: string | null,
    conditionGroup: string | null
  ): Promise<Condition | null> {
    const parameters: Record<string, any> = {}
    if (conditionId) parameters['condition_id'] = conditionId
    if (filterCnf) parameters['filter_cnf_str'] = this.jsonifyFilterCnfStr(filterCnf)
    if (active !== null) parameters['active'] = active
    if (conditionName) parameters['condition_name'] = conditionName
    if (conditionGroup) parameters['condition_group'] = conditionGroup
    return this.withApiKey(async (apiKey) => {
      return standardPut<Condition>(
        buildUrl(this.hostname, CONDITIONS),
        { 
          api_key: apiKey,
          ...parameters
        },
        {},
        jsonSafeToCondition
      )
    })
  }

  async getPlays(): Promise<Play[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<Play[]>(
        buildUrl(this.hostname, PLAYS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonSafeToPlayResult
      )
    })
  }

  async putPlay(
    playId: string | null,
    conditionId: string | null,
    active: boolean | null,
    promptText: string | null,
    weight: number | null,
    playName: string | null,
    minDuration: number | null
  ): Promise<Play | null> {
    const parameters: Record<string, any> = {}
    if (playId) parameters['play_id'] = playId
    if (conditionId) parameters['condition_id'] = conditionId
    if (active !== null) parameters['active'] = active
    if (promptText) parameters['prompt_text'] = promptText
    if (weight !== null) parameters['weight'] = weight
    if (playName) parameters['play_name'] = playName
    if (minDuration !== null) parameters['min_duration'] = minDuration
    return this.withApiKey(async (apiKey) => {
      return standardPut<Play>(
        buildUrl(this.hostname, PLAYS),
        { 
          api_key: apiKey,
          ...parameters
        },
        {},
        jsonSafeToPlay
      )
    })
  }

  // ==================== PASSWORD MANAGEMENT ====================

  async requestPasswordResetEmail(email: string): Promise<boolean> {
    const result = await standardPost<Response>(
      buildUrl(this.hostname, PASSWORD_RESET_REQUEST),
      { email },
      { noJsonification: true }
    )
    return result?.status === 200
  }

  async resetPassword(email: string, recoveryCode: string, password: string): Promise<AuthResult | null> {
    return standardPost<AuthResult>(
      buildUrl(this.hostname, PASSWORD_RESET),
      { email, recovery_code: recoveryCode, password },
    )
  }

  // ==================== BOT MANAGEMENT ====================

  async getAllTeamBots(): Promise<Bot[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<Bot[]>(
        buildUrl(this.hostname, TEAM_BOTS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonSafeToBots
      )
    })
  }

  async getAllGlobalBots(): Promise<Bot[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<Bot[]>(
        buildUrl(this.hostname, GLOBAL_BOTS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonSafeToBots
      )
    })
  }

  async getProspectBots(prospectId: string): Promise<Bot[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<Bot[]>(
        buildUrl(this.hostname, PROSPECT_BOTS),
        { api_key: apiKey, prospect_id: prospectId },
        { cacheable: false },
        jsonSafeToBots
      )
    })
  }

  async getAllEmotions(botIds: string[]): Promise<BotEmotion[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<BotEmotion[]>(
        buildUrl(this.hostname, BOT_EMOTIONS),
        { api_key: apiKey, bot_ids: botIds }
      )
    })
  }

  private _formatSessionData(sessionData: SessionDataResult): string {
    // Format a single session's transcript with speaker labels
    const turns = sessionData.turns
      .filter(turn => turn.text.trim() !== '')
      .sort((a, b) => a.start - b.start)
      .map(turn => {
        const speaker = turn.role === PartyRole.PROSPECT ? 'Prospect' : 'You'
        return `${speaker}: ${turn.text}`
      })
      .join('"' + String.fromCharCode(10) + '"')

    const name = `Call with ${sessionData.prospect_info?.prospect_name || 'Unknown'}`
    const title = (sessionData.prospect_info?.prospect_occupation || sessionData.prospect_info?.prospect_title || null)
    return `${name}${title ? ` - (${title})` : ''}\n\n${turns}`
  }

  private _formatSessionDatas(sessionDatas: SessionDataResult[]): string {
    // Format multiple sessions with clear separation
    return sessionDatas
      .map(session => this._formatSessionData(session))
      .join('\n\n---\n\n')
  }

  async generateBot(sessions: SessionDataResult[], valueProp: EmailValueProp | null): Promise<BotGeneration | null> {
    const parameters: Record<string, any> = {
      'transcripts': this._formatSessionDatas(sessions),
    }
    const value_prop_str = this._formatValueProp(valueProp)
    if (value_prop_str) parameters['value_prop'] = value_prop_str
    
    return this.withApiKey(async (apiKey) => {
      return standardPost<BotGeneration>(
        buildUrl(this.hostname, BOT_GENERATOR),
        { api_key: apiKey, ...parameters }
      )
    })
  }

  async generateBotFromProspectInformation(emailInputData: any, valueProp: EmailValueProp | null): Promise<BotGeneration | null> {
    return this.withApiKey(async (apiKey) => {
      // Validate required fields similar to the old implementation
      if (!emailInputData.prospect_name || 
          !emailInputData.prospect_title || 
          !emailInputData.agent_data?.COMPANY_WEBSITE?.info || 
          !valueProp) {
        return null
      }

      // Format prospect information into string format as expected by the backend
      const prospect_info = this._constructProspectInformation(
        emailInputData.prospect_name,
        emailInputData.prospect_title,
        emailInputData.prospect_company,
        emailInputData.agent_data.COMPANY_WEBSITE
      )

      // Format value prop as expected by the backend
      const value_prop_formatted = this._formatValueProp(valueProp)

      return standardPost<BotGeneration>(
        buildUrl(this.hostname, BOT_GENERATOR),
        { 
          api_key: apiKey, 
          prospect_information: prospect_info, 
          value_prop: value_prop_formatted 
        }
      )
    })
  }

  // Helper methods copied from old implementation
  private _constructProspectInformation(
    prospect_name: string,
    prospect_title: string,
    prospect_company: string | null,
    prospect_company_data: any,
  ): string {
    // try to split the name into first and last
    let name = prospect_name.trim()
    try {
      const name_parts = name.split(' ')
      if (name_parts.length > 1) {
        name = name_parts[0]
      }
    } catch (e) {
      // logInfo(`Unexpected error from construct prospect information`, e)
    }
    const temp = `
    Prospect Name: ${name}
    Prospect Title: ${prospect_title}
    Prospect Company: ${prospect_company || 'N/A'}
    `
    let company_description = null
    if (prospect_company_data.info?.summary) {
      company_description = prospect_company_data.info.summary
    } else if (prospect_company_data.info?.header_and_content) { 
      company_description = prospect_company_data.info.header_and_content.map((v: any) => `${v.header}: ${v.content}`).join('"' + String.fromCharCode(10) + '"')
    }
    if (company_description) {
      return `${temp}\n\nProspect Company Description: ${company_description}`
    }
    return temp
  }

  private _formatValueProp(value_prop: EmailValueProp | null): string | null {
    if (!value_prop) return null
    return `
      Pain Point: ${value_prop.pain_point}
      Solution: ${value_prop.solution}
      Prospect Benefits: ${value_prop.prospect_benefits}
    `.trim()
  }

  async getBotCall(botCallId: string): Promise<BotCall | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<BotCall>(
        buildUrl(this.hostname, BOT_CALL),
        { api_key: apiKey, bot_call_id: botCallId }, 
        { cacheable: false },
        jsonSafeToBotCall
      )
    })
  }

  async getSynthCalls(query: BotSessionQueryParams): Promise<BotCall[] | null> {
    const parameters: Record<string, any> = {}
    const bot_ids = (query.bot_ids ?? []).filter((v) => v)
    const user_ids = (query.user_ids ?? []).filter((v) => v)
    if (bot_ids.length > 0) parameters['bot_ids'] = bot_ids
    if (user_ids.length > 0) parameters['user_ids'] = user_ids
    if (query.start) parameters['start'] = query.start.getTime()*MS_TO_MICRO
    if (query.end) parameters['end'] = query.end.getTime()*MS_TO_MICRO
    if (query.min_score) parameters['min_score'] = query.min_score
    if (query.max_score) parameters['max_score'] = query.max_score
    return this.withApiKey(async (apiKey) => {
      return standardGet<BotCall[]>(
        buildUrl(this.hostname, BOT_CALLS),
        { api_key: apiKey, ...parameters },
        { cacheable: false },
        jsonSafeToBotCalls
      )
    })
  }

  async initiateSynthSession(botId: string, callDifficulty: CallDifficultyMode): Promise<BotCall | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<BotCall>(
        buildUrl(this.hostname, BOT_CALL),
        { api_key: apiKey, bot_id: botId, difficulty_level: callDifficulty },
        { rawResponse: true },
        async (response) => {
          if (!response) return null
          if (response.status !== 200) {
            const text = await response.text()
            return text
          }
          const json = await responseToJson(response)
          return jsonSafeToBotCall(json)
        }
      )
    })
  }

  async getBotCallAnalysis(call: BotCall, transcripts: BotCallTranscript[]): Promise<BotCall | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<BotCall>(
        buildUrl(this.hostname, BOT_CALL_ANALYSIS),
        { 
          api_key: apiKey, 
          bot_id: call.bot_id,
          bot_call_id: call.bot_call_id,
          transcripts: this._formatCallTranscript(transcripts)
        },
        {},
        jsonSafeToBotCall
      )
    })
  }

  private _formatCallTranscript(transcripts: BotCallTranscript[]): string {
    if (transcripts.length === 0) return ''
    const sorted_transcripts = [...transcripts].sort((a, b) => a.timestamp - b.timestamp)
    // join like parts together
    let final_transcript_str = ''
    let last_party: boolean | null = null
    for (const transcript of sorted_transcripts) {
      if (transcript.is_rep === last_party) {
        final_transcript_str += ` ${transcript.text}`
      } else {
        final_transcript_str += `\n${transcript.is_rep ? 'Rep' : 'Prospect'}: ${transcript.text}`
      }
      last_party = transcript.is_rep
    }
    return final_transcript_str
  }

  async deleteBot(botId: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, TEAM_BOTS),
        { api_key: apiKey, bot_id: botId, delete: true },
        { statusOnly: true }
      )
    })
  }

  async deleteEmotion(botId: string, emotion: CallBotEmotion): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, BOT_EMOTIONS),
        { api_key: apiKey, bot_id: botId, emotion, delete: true },
        { statusOnly: true }
      )
    })
  }

  async addBot(bot: Bot): Promise<Bot | null> {
    return this.withApiKey(async (apiKey) => {
      const parameters: Record<string, any> = {
        api_key: apiKey,
        ...bot
      }
      // Remove bot_id and handle tags like the old implementation
      delete parameters['bot_id']
      delete parameters['tags']
      if (bot.tags) parameters['tags'] = bot.tags.join(',')
      
      return standardPut<Bot>(
        buildUrl(this.hostname, TEAM_BOTS),
        parameters,
        {},
        jsonSafeToBot
      )
    })
  }

  async addEmotion(botId: string, emotion: CallBotEmotion): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, BOT_EMOTIONS),
        { api_key: apiKey, bot_id: botId, emotion },
        { statusOnly: true }
      )
    })
  }

  async updateBot(bot: Bot): Promise<Bot | null> {
    return this.withApiKey(async (apiKey) => {
      const parameters: Record<string, any> = {
        api_key: apiKey,
        ...bot
      }
      // Handle tags like the old implementation
      delete parameters['tags']
      if (bot.tags) parameters['tags'] = bot.tags.join(',')
      
      return standardPut<Bot>(
        buildUrl(this.hostname, TEAM_BOTS),
        parameters,
        {},
        jsonSafeToBot
      )
    })
  }

  async getGlobalBotSkills(): Promise<BotSkill[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<BotSkill[]>(
        buildUrl(this.hostname, GLOBAL_BOT_SKILLS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES }
      )
    })
  }

  async getTeamBotSkills(): Promise<BotSkill[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<BotSkill[]>(
        buildUrl(this.hostname, TEAM_BOT_SKILLS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES }
      )
    })
  }

  async generateBotSkill(description: string, valueProp: EmailValueProp | null): Promise<BotSkill | null> {
    const parameters: Record<string, any> = { description }
    if (valueProp) parameters['value_prop'] = this._formatValueProp(valueProp)
    return this.withApiKey(async (apiKey) => {
      return standardGet<BotSkill>(
        buildUrl(this.hostname, BOT_SKILL_GENERATOR),
        { api_key: apiKey, ...parameters }
      )
    })
  }

  async addBotSkill(botSkill: BotSkill): Promise<BotSkill | null> {
    return this.withApiKey(async (apiKey) => {
      const parameters: Record<string, any> = {
        api_key: apiKey,
        ...botSkill
      }
      // Remove bot_skill_id when creating like the old implementation
      delete parameters['bot_skill_id']
      
      return standardPut<BotSkill>(
        buildUrl(this.hostname, TEAM_BOT_SKILLS),
        parameters
      )
    })
  }

  async updateBotSkill(botSkill: BotSkill): Promise<BotSkill | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<BotSkill>(
        buildUrl(this.hostname, TEAM_BOT_SKILLS),
        { api_key: apiKey, ...botSkill }
      )
    })
  }

  async deleteBotSkill(botSkillId: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, TEAM_BOT_SKILLS),
        { api_key: apiKey, bot_skill_id: botSkillId, delete: true },
        { statusOnly: true }
      )
    })
  }

  // ==================== CUSTOM DEFINITIONS ====================

  async getCustomDefinitions(): Promise<CustomDefinition[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<CustomDefinition[]>(
        buildUrl(this.hostname, CUSTOM_DEFINITIONS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonSafeToCustomDefinitions  
      )
    })
  }

  async putCustomDefinitions(definitions: CustomDefinition[], mock?: boolean): Promise<CustomDefinition[] | string | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<CustomDefinition[] | string>(
        buildUrl(this.hostname, CUSTOM_DEFINITIONS),
        { api_key: apiKey, definitions, mock },
        {rawResponse: true}, 
        async (response) => {
          if (!response) return 'Invalid response'
          if (response.status !== 200) {
            const text = await response.text()
            return text
          }
          const json: Record<string, any> = await response.json()
          return jsonSafeToCustomDefinitions(json)
        }
      )
    })
  }

  async requestCustomMetricTesting(sessionId: string, metrics: CustomDefinition[]): Promise<MetricResult | null> {
    const parameters: Record<string, any> = {
      session_id: sessionId,
      custom_definitions: metrics.map(((v) => {
        return {
          ...v,
          modified_as_of: null,
          rebuilt_as_of: null,
        }
      }))
    }
    return this.withApiKey(async (apiKey) => {
      return standardGet<MetricResult>(
        buildUrl(this.hostname, REQUEST_CUSTOM_METRIC),
        { api_key: apiKey, ...parameters }
      )
    })
  }

  // ==================== EMAIL VALUE PROPS ====================

  async getEmailValueProp(): Promise<EmailValueProp[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<EmailValueProp[]>(
        buildUrl(this.hostname, EMAIL_VALUE_PROP),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES }
      )
    })
  }

  async generateProspectEmail(emailGenRequest: EmailGenRequest): Promise<AIProspectEmail | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<AIProspectEmail>(
        buildUrl(this.hostname, REQUEST_PROSPECT_EMAIL_GEN),
        { api_key: apiKey, ...emailGenRequest },
        {},
        jsonSafeToAIProspectEmail
      )
    })
  }

  async generateRevisionEmail(
    emailGenRequest: EmailGenRequest, 
    previousEmail: string, 
    customEditInfo: CustomEditInfo): Promise<AIProspectEmail | null> {
      const parameters: Record<string, any> = {
        previous_email: encodeURIComponent(previousEmail),
        ...emailGenRequest,
      }
      if (customEditInfo.custom_tone) parameters['custom_tone'] = customEditInfo.custom_tone 
      if (customEditInfo.custom_instructions) parameters['custom_instruction'] = customEditInfo.custom_instructions
      return this.withApiKey(async (apiKey) => {
      return standardGet<AIProspectEmail>(
        buildUrl(this.hostname, REQUEST_PROSPECT_EMAIL_GEN_REVISION),
        { api_key: apiKey, ...parameters },
        {},
        jsonSafeToAIProspectEmail
      )
    })
  }

  async generateLinkedInMessage(linkedinGenRequest: LinkedInGenRequest): Promise<LinkedInGeneratedMessage | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<LinkedInGeneratedMessage>(
        buildUrl(this.hostname, REQUEST_PROSPECT_LINKEDIN_GEN),
        { api_key: apiKey, ...linkedinGenRequest },
        {},
        jsonSafeToLinkedInGeneratedEmail
      )
    })
  }

  async generateRevisionLinkedin(linkedinGenRequest: LinkedInGenRequest, previousMessage: string, customEditInfo: CustomEditInfo): Promise<LinkedInGeneratedMessage | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<LinkedInGeneratedMessage>(
        buildUrl(this.hostname, REQUEST_PROSPECT_LINKEDIN_REVISION),
        { api_key: apiKey, ...linkedinGenRequest, previous_message: previousMessage, custom_edit_info: customEditInfo },
        {},
        jsonSafeToLinkedInGeneratedEmail
      )
    })
  }

  // ==================== TEXTING ====================

  async getTextingNumbers(): Promise<RegisteredTwilioNumber[] | null> {
    const result = await this.withApiKey(async (apiKey) => {
      return standardGet<RegisteredTwilioNumber[]>(
        buildUrl(this.hostname, TWILIO_NUMBERS),
        { api_key: apiKey, whole_team: true },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonSafeToRegisteredTwilioNumbers
      )
    })
    if (!result) return null
    return result.filter((number) => number.twilio_messaging_sid !== null)
  }

  async sendTextMessage(from: RegisteredTwilioNumber, to: string, message: string): Promise<SessionV2 | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<SessionV2>(
        buildUrl(ROUTER_HOSTNAME, RT_ROUTER_ENSURE_SESSION_USER_MESSAGE),
        { 
          api_key: apiKey, 
          agent_address: from.rep_phone_value,
          customer_address: to,
          text: message
        },
        {},
        jsonSafeToSessionV2
      )
    })
  }

  async getMyTwilioNumbers(): Promise<RegisteredTwilioNumber[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<RegisteredTwilioNumber[]>(
        buildUrl(this.hostname, TWILIO_NUMBERS),
        { api_key: apiKey, rented: true },
        {},
        jsonSafeToRegisteredTwilioNumbers
      )
    })
  }

  async getTwilioNumbersForUser(targetUserId: string, seeRented: boolean = true): Promise<RegisteredTwilioNumber[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<RegisteredTwilioNumber[]>(
        buildUrl(this.hostname, TWILIO_NUMBERS),
        { api_key: apiKey, user_id: targetUserId, see_rented: seeRented },
        {},
        jsonSafeToRegisteredTwilioNumbers
      )
    })
  }

  // ==================== SNIPPETS ====================

  async getSnippets(): Promise<Snippet[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<Snippet[]>(
        buildUrl(this.hostname, SNIPPETS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonSafeToSnippets
      )
    })
  }

  async deleteSnippet(snippetId: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardDelete<boolean>(
        buildUrl(this.hostname, SNIPPETS),
        { api_key: apiKey, snippet_id: snippetId }
      ) !== null
    })
  }

  async createSnippet(isTeam: boolean, isGlobal: boolean, userGroupId: string | null, snippetName: string, snippetText: string): Promise<Snippet | null> {
    if (isTeam && userGroupId) return null
    if (isGlobal && (userGroupId || isTeam)) return null
    return this.withApiKey(async (apiKey) => {
      return standardPut<Snippet>(
        buildUrl(this.hostname, SNIPPETS),
        { 
          api_key: apiKey, 
          is_team: isTeam, 
          is_global: isGlobal, 
          user_group_id: userGroupId, 
          snippet_name: snippetName, 
          snippet_text: snippetText 
        },
        {},
        jsonSafeToSnippet
      )
    })
  }

  async updateSnippet(snippetId: string, snippetName: string, snippetText: string): Promise<Snippet | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<Snippet>(
        buildUrl(this.hostname, SNIPPETS),
        { api_key: apiKey, snippet_id: snippetId, snippet_name: snippetName, snippet_text: snippetText },
        {},
        jsonSafeToSnippet
      )
    })
  }

  // ==================== LINKEDIN VOICE MEMOS ====================

  async getLinkedInVoiceMemos(all?: boolean, userId?: string): Promise<LinkedInVoiceMemoMetadata[] | null> {
    const parameters: Record<string, any> = {}
    if (all) parameters['all'] = ''
    return this.withApiKey(async (apiKey) => {
      // Get current user to filter by user_id
      const result = await standardGet<LinkedInVoiceMemoMetadata[]>(
        buildUrl(this.hostname, LINKEDIN_VOICE_MEMOS),
        {
          ...parameters,
          api_key: apiKey
        }
      )
      if (!result) return null
      if (userId) return result.filter(memo => memo.user_id === userId)
      return result
    })
  }

  async downloadLinkedInVoiceMemo(linkedinVoiceMemoId: string): Promise<Blob | null> {
    return this.withApiKey(async (apiKey) => {
      const result = await standardGet<any>(
        buildUrl(this.hostname, LINKEDIN_VOICE_MEMOS),
        { api_key: apiKey, linkedin_voice_memo_id: linkedinVoiceMemoId }
      )
      if (!result) return null
      const download = await fetch(result)  
      return download.blob()
    })
  }

  async deleteLinkedInVoiceMemo(linkedinVoiceMemoId: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardDelete<boolean>(
        buildUrl(this.hostname, LINKEDIN_VOICE_MEMOS),
        { api_key: apiKey, linkedin_voice_memo_id: linkedinVoiceMemoId }
      ) !== null
    })
  }

  async createLinkedInVoiceMemo(file: Blob, name: string): Promise<LinkedInVoiceMemoMetadata | null> {
    return this.withApiKey(async (apiKey) => {
      const formData = new FormData() 
      formData.append('api_key', apiKey)
      formData.append('file', file)
      formData.append('name', name)
      return await standardPost<LinkedInVoiceMemoMetadata>(
        buildUrl(this.hostname, LINKEDIN_VOICE_MEMOS),
        formData
      )
    })
  }

  async replaceLinkedInVoiceMemo(linkedinVoiceMemoId: string, file: Blob): Promise<LinkedInVoiceMemoMetadata | null> {
    return this.withApiKey(async (apiKey) => {
      const formData = new FormData() 
      formData.append('api_key', apiKey)
      formData.append('linkedin_voice_memo_id', linkedinVoiceMemoId)
      formData.append('file', file)
      return await standardPost<LinkedInVoiceMemoMetadata>(
        buildUrl(this.hostname, LINKEDIN_VOICE_MEMOS),
        formData
      )
    })
  }

  async renameLinkedInVoiceMemo(linkedinVoiceMemoId: string, name: string): Promise<LinkedInVoiceMemoMetadata | null> {
    return this.withApiKey(async (apiKey) => {
      const formData = new FormData() 
      formData.append('api_key', apiKey)
      formData.append('linkedin_voice_memo_id', linkedinVoiceMemoId)
      formData.append('name', name)
      return await standardPost<LinkedInVoiceMemoMetadata>(
        buildUrl(this.hostname, LINKEDIN_VOICE_MEMOS),
        formData
      )
    })
  }

  // ==================== MULTIDIALER & QUOTAS ====================

  async getMultidialerQuota(): Promise<MultiDialerQuotaInfo | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<MultiDialerQuotaInfo>(
        buildUrl(this.hostname, MULTIDIALER_SETTINGS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonSafeToQuotaInfo
      )
    })
  }

  // ==================== GOOGLE OAUTH ====================

  async exchangeCodeForTokens(code: string, redirectUri: string): Promise<GoogleTokenConfig | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<GoogleTokenConfig>(
        buildUrl(this.hostname, GOOGLE_EXCHANGE_CODE),
        { api_key: apiKey, code, redirect_uri: redirectUri }
      )
    })
  }

  async getCurrentToken(forceRefresh?: boolean): Promise<GoogleTokenConfig | null> {
    const parameters: Record<string, any> = {} 
    if (forceRefresh) parameters['force_refresh'] = forceRefresh
    return this.withApiKey(async (apiKey) => {
      return standardGet<GoogleTokenConfig>(
        buildUrl(this.hostname, GOOGLE_GET_CURRENT_TOKEN),
        { api_key: apiKey, ...parameters }
      )
    })
  }

  // ==================== WEATHER ====================

  async getWeather(phoneNumber: string): Promise<WeatherData | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<WeatherData>(
        buildUrl(this.hostname, SERVICES_WEATHER),
        { api_key: apiKey, phone_number: phoneNumber },
        {},
        jsonSafeToWeatherData
      )
    })
  }

  // ==================== REVIEW COUNTS ====================

  async getReviewCounts(isOpen: boolean, start: Date, end: Date): Promise<ReviewCount[] | null> {
    const parameters: Record<string, any> = {
      start: start.getTime() * MS_TO_MICRO, 
      end: end.getTime() * MS_TO_MICRO 
    }
    if (isOpen) parameters['is_open'] = isOpen
    return this.withApiKey(async (apiKey) => {
      return standardGet<ReviewCount[]>(
        buildUrl(this.hostname, REVIEW_COUNTS),
        { 
          api_key: apiKey, 
          ...parameters
        },
        {},
        jsonSafeToReviewCounts  
      )
    })
  }

  // ==================== AI MANY CALL ANALYSIS ====================

  async getAIManyCallAnalysis(userIds: string[]): Promise<AIManyCallAnalysis[]> {
    const result = await this.withApiKey(async (apiKey) => {
      return standardGet<AIManyCallAnalysis[]>(
        buildUrl(this.hostname, AI_MANY_CALL_ANALYSIS_V2),
        { api_key: apiKey, user_ids: userIds },
        {},
        jsonSafeToMultiAICallAnalysis
      )
    })
    return result || []
  }

  // ==================== AUTODIALER ====================

  async getAutodialerSettings(): Promise<AutoDialerSetting[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<AutoDialerSetting[]>(
        buildUrl(this.hostname, AUTODIALER_SETTINGS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonSafeToAutodialerSettings
      )
    })
  }

  async putAutodialerSettings(autodialerSettings: AutoDialerSetting, userSelection: UserSelection): Promise<boolean | null> {
    const parameters: Record<string, any> = {...autodialerSettings}
    for (const key of Object.keys(parameters)) {
      if (parameters[key] === null) delete parameters[key]
      if (parameters[key] && key === SETTING.PHONE_PREFERENCE) parameters[key] = JSON.stringify(parameters[key])
    }
    if (userSelection.type === SelectionType.OVERALL_TEAM) parameters['is_team'] = true
    if (userSelection.type === SelectionType.SUB_TEAM) parameters['user_group_id'] = userSelection.id
    if (userSelection.type === SelectionType.USER) parameters['locked_user_id'] = userSelection.id

    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, AUTODIALER_SETTINGS),
        { api_key: apiKey, ...parameters },
        { statusOnly: true }
      )
    })
  }

  async getAutodialerMappingOptions(): Promise<AutoDialerMappingOptions[] | null> {
    return this.withApiKey(async (apiKey) => {
      return await standardGet<AutoDialerMappingOptions[]>(
        buildUrl(this.hostname, AUTODIALER_MAPPING_OPTIONS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonSafeToAutodialerMappingOptionsList
      )
    })
  }

  async getAutodialerMappings(): Promise<AutoDialerMapping[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<AutoDialerMapping[]>(
        buildUrl(this.hostname, AUTODIALER_MAPPINGS),
        { api_key: apiKey },
      )
    })
  }

  async putAutodialerMappings(
    autodialerMapping: AutoDialerMapping,
    userSelection: UserSelection,
    isRemove: boolean
  ): Promise<boolean | null> {
    const parameters: Record<string, any> = {
      is_remove: isRemove,
      platform: autodialerMapping.platform,
      automation_type: autodialerMapping.automation_type,
      trellus_disposition: autodialerMapping.trellus_disposition,
    }
    
    if (!isRemove && autodialerMapping.value) {
      parameters['value'] = autodialerMapping.value
    }
    
    // Handle user selection similar to putAutodialerSettings
    if (userSelection.type === SelectionType.OVERALL_TEAM) {
      parameters['is_team'] = true
    }
    if (userSelection.type === SelectionType.SUB_TEAM) {
      parameters['user_group_id'] = userSelection.id
    }
    if (userSelection.type === SelectionType.USER) {
      parameters['locked_user_id'] = userSelection.id
    }
    
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, AUTODIALER_MAPPINGS),
        {
          api_key: apiKey,
          ...parameters
        },
        { statusOnly: true }
      )
    })
  }

  async getAllAutodialerSettings(): Promise<AutoDialerSetting[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<AutoDialerSetting[]>(
        buildUrl(this.hostname, ALL_AUTODIALER_SETTINGS),
        { api_key: apiKey },
        {},
        jsonSafeToAutodialerSettings
      )
    })
  }

  async getAllAutodialerMappings(): Promise<AutoDialerMapping[] | null> {   
    return this.withApiKey(async (apiKey) => {
      return standardGet<AutoDialerMapping[]>(
        buildUrl(this.hostname, ALL_AUTODIALER_MAPPINGS),
        { api_key: apiKey },
        {},
      )
    })
  }


  // ==================== ADMIN METHODS ====================

  async admin_getAllUsers(teamIds?: string[]): Promise<UserAndUserAuthResult[] | null> {
    const parameters: Record<string, any> = {}
    if (teamIds) parameters['team_ids'] = teamIds
    return this.withApiKey(async (apiKey) => {
      return standardGet<UserAndUserAuthResult[]>(
        buildUrl(this.hostname, USER_ADMIN),
        { api_key: apiKey, ...parameters },
        {},
        jsonSafeToUserAndUserAuthResults
      )
    })
  }

  async admin_updateUser(userId: string, settingUpdate: AdminUserSettingsUpdate): Promise<boolean | null> {
    const parameters: Record<string, any> = {
      user_id: userId,
    }
    if (settingUpdate.autodialer_paid !== undefined) parameters['autodialer_paid'] = settingUpdate.autodialer_paid
    if (settingUpdate.can_dial !== undefined) parameters['can_dial'] = settingUpdate.can_dial
    if (settingUpdate.team_is_active !== undefined) parameters['team_is_active'] = settingUpdate.team_is_active
    if (settingUpdate.autodialer_weekly_limit !== undefined) parameters['autodialer_weekly_limit'] = settingUpdate.autodialer_weekly_limit
    if (settingUpdate.parallel_enabled !== undefined) parameters['parallel_enabled'] = settingUpdate.parallel_enabled
    if (settingUpdate.defaults_to_native_engine !== undefined) parameters['defaults_to_native_engine'] = settingUpdate.defaults_to_native_engine
    if (settingUpdate.defaults_to_trellus_line !== undefined) parameters['defaults_to_trellus_line'] = settingUpdate.defaults_to_trellus_line
    if (settingUpdate.can_use_new_trellus_dialer !== undefined) parameters['can_use_new_trellus_dialer'] = settingUpdate.can_use_new_trellus_dialer
    if (settingUpdate.trellus_only_for_parallel !== undefined) parameters['trellus_only_for_parallel'] = settingUpdate.trellus_only_for_parallel
    if (settingUpdate.only_native_lines !== undefined) parameters['only_native_lines'] = settingUpdate.only_native_lines
    if (settingUpdate.mixed_use_dialing !== undefined) parameters['mixed_use_dialing'] = settingUpdate.mixed_use_dialing
    if (settingUpdate.enqueue_engine_enabled !== undefined) parameters['enqueue_engine_enabled'] = settingUpdate.enqueue_engine_enabled
    
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, USER_ADMIN),
        { api_key: apiKey, ...parameters },
        { statusOnly: true }
      )
    })
  }

  async admin_getAllTeams(options: {search?: string, teamIds?: string[]} = {}): Promise<TeamResult[] | null> {
    const parameters: Record<string, any> = {}
    if (options.search) parameters['search'] = options.search
    if (options.teamIds) parameters['team_ids'] = options.teamIds
    return this.withApiKey(async (apiKey) => {
      return standardGet<TeamResult[]>(
        buildUrl(this.hostname, TEAM_ADMIN),
        { api_key: apiKey, ...parameters },
        {},
        jsonSafeToTeamResults
      )
    })
  }

  async admin_updateTeam(teamId: string, settingUpdate: AdminTeamSettingUpdate): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, TEAM_ADMIN),
        { api_key: apiKey, team_id: teamId, update: settingUpdate },
        { statusOnly: true }
      )
    })
  }

  async admin_getAllScopes(teamIds?: string[]): Promise<ScopeV2[] | null> {
    const parameters: Record<string, any> = {}
    if (teamIds) parameters['team_ids'] = teamIds
    return this.withApiKey(async (apiKey) => {
      return standardGet<ScopeV2[]>(
        buildUrl(this.hostname, SCOPE_ADMIN),
        { api_key: apiKey, ...parameters }
      )
    })
  }

  async admin_updateScope(scope: ScopeV2, isRemove: boolean): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, SCOPE_ADMIN),
        { api_key: apiKey, scope, is_remove: isRemove },
        { statusOnly: true }
      )
    })
  }

  async admin_updateDomain(teamId: string, domain: string | null): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, DOMAIN_ADMIN),
        { api_key: apiKey, team_id: teamId, domain },
        { statusOnly: true }
      )
    })
  }

  async admin_updateParallelDialerQuotas(teamId: string, changedQuotas: ParallelDialerQuotasUpdate): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<boolean>(
        buildUrl(this.hostname, MULTIDIALER_ADMIN),
        { api_key: apiKey, team_id: teamId, ...changedQuotas },
      )
    }) !== null
  }

  async admin_removeParallelDialerAccess(teamId: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return (standardPost<boolean>(
        buildUrl(this.hostname, MULTIDIALER_ADMIN_V2),
        { api_key: apiKey, team_id: teamId, delete: true }
      ) !== null)
    })
  }

  async admin_getParallelDialerAccessInfo(teamIds?: string[]): Promise<ParallelDialerAccessInfo | null> {
    const parameters: Record<string, any> = {}
    if (teamIds) parameters['team_ids'] = teamIds
    return this.withApiKey(async (apiKey) => {
      return standardGet<ParallelDialerAccessInfo>(
        buildUrl(this.hostname, MULTIDIALER_ADMIN_V2),
        { api_key: apiKey, ...parameters },
        {},
        jsonSafeToParallelDialerAccessInfo
      )
    })
  }

  // ==================== SEATS ====================

  async putSeats(targetUserId: string, teamIsActive?: boolean, canDial?: boolean): Promise<boolean | null> {
    const parameters: Record<string, any> = { user_id: targetUserId }
    if (teamIsActive !== undefined) parameters['team_is_active'] = teamIsActive
    if (canDial !== undefined) parameters['can_dial'] = canDial
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, SEATS),
        { api_key: apiKey, ...parameters },
        { statusOnly: true }
      )
    })
  }

  // ==================== TEAM INVITATIONS AND MEMBERS ====================

  async getReceivedTeamInvitations(): Promise<TeamInvitation[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<TeamInvitation[]>(
        buildUrl(this.hostname, TEAM_INVITATIONS),
        { api_key: apiKey },
        {},
        a => a.map(jsonSafeToTeamInvitation),
      )
    })
  }

  async getSentTeamInvitations(): Promise<TeamInvitation[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<TeamInvitation[]>(
        buildUrl(this.hostname, TEAM_INVITATIONS),
        { api_key: apiKey, sent: true },
        {},
        a => a.map(jsonSafeToTeamInvitation),
      )
    })
  }

  async acceptTeamInvitation(teamId: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<boolean>(
        buildUrl(this.hostname, TEAM_INVITATIONS),
        { api_key: apiKey, accept: teamId },
      )
    })
  }

  async createTeamInvitation(email: string, canDial: boolean): Promise<TeamInvitation | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<TeamInvitation>(
        buildUrl(this.hostname, TEAM_INVITATIONS),
        { api_key: apiKey, invite: email, can_dial: canDial },
        {},
        jsonSafeToTeamInvitation,
      )
    })
  }

  // Rescind an invitation for the user with the given email address to join your team.
  // Returns the number of invitations deleted (may be zero), or null if there was an error.
  async rescindTeamInvitation(email: string): Promise<number | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<number>(
        buildUrl(this.hostname, TEAM_INVITATIONS),
        { api_key: apiKey, uninvite: email },
      )
    })
  }

  // Kick a user out of your team by userId, spinning them out into a newly created team.
  // Requires ADMIN_WRITE privileges, unless userId is you.
  // Is a no-op if userId is you and you have no other teammates.
  // Resets most Team settings if it wasn't a no-op.
  // Returns a TeamResult representing the newly created team.
  async removeUserFromCurrentTeam(userId: string): Promise<TeamResult | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<TeamResult>(
        buildUrl(this.hostname, TEAM_MEMBERS),
        { api_key: apiKey, remove_user_id: userId },
      )
    })
  }

  // ==================== TWILIO ADMIN ====================

  async getAllTwilioNumbersAdmin(): Promise<RegisteredTwilioNumber[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<RegisteredTwilioNumber[]>(
        buildUrl(this.hostname, TWILIO_NUMBERS_ADMIN),
        { api_key: apiKey },
        {},
        jsonSafeToRegisteredTwilioNumbers
      )
    })
  }

  async registerNumberResponseToNumberOrError(
    response: Response,
    requested_phone_number: string,
  ): Promise<RegisteredTwilioNumber | string> {
    switch (response.status) {
      case 200:
        return await response.json() as RegisteredTwilioNumber
      case 403:
        return `Numbers limit reached; ${requested_phone_number} not registered.`
      case 404:
        return `${requested_phone_number} is no longer available.`
      default:
        return `Failed to purchase ${requested_phone_number}.`
    }
  }

  async registerTwilioNumber(twilioNumber: OptionalTwilioNumber, countryIsoCode?: string, numberType?: 'Local' | 'Mobile' | 'TollFree'): Promise<RegisteredTwilioNumber | string> {
    const parameters: Record<string, any> = {
      phone_number: twilioNumber.phone_number
    }
    if (countryIsoCode) parameters['country'] = countryIsoCode
    if (numberType) parameters['number_type'] = numberType
    const result = await this.withApiKey(async (apiKey) => {
      const response = await standardPost<Response>(
        buildUrl(this.hostname, TWILIO_NUMBERS),
        { api_key: apiKey, ...parameters },
        { noJsonification: true }
      )
      if (!response) return "Unauthorized"
      return await this.registerNumberResponseToNumberOrError(response, twilioNumber.phone_number)
    })
    return result || "Unauthorized"
  }

  async unregisterTwilioNumber(repPhoneValue: string): Promise<string | null> {
    return this.withApiKey(async (apiKey) => {
        const response = await standardPost<Response>(
          buildUrl(this.hostname, TWILIO_NUMBERS),
          { api_key: apiKey, phone_number: repPhoneValue, delete: true },
          { noJsonification: true }
        )
        if (response === null) {
          return "Not logged in"
        } else if (response.status === 404) {
          return "Registration not found"
        } else if (response.status === 409) {
          return "Too many deregistrations this month"
        } else if (response.status >= 400) {
          return "Server error"
        }
        return null
    }) || "Not logged in"
  }

  async getOptionsForTwilioNumber(options: {
    area_code?: string | null,
    iso_country_code?: string | null,
    state_or_province?: string | null,
    substring?: string | null,
    number_type?: 'Local' | 'Mobile' | 'TollFree'
  }): Promise<OptionalTwilioNumber[] | null> {
    const parameters: Record<string, any> = {
    }
    if (options.area_code) parameters['area_code'] = options.area_code
    if (options.iso_country_code) parameters['country'] = options.iso_country_code
    if (options.state_or_province) parameters['state_or_province'] = options.state_or_province
    if (options.substring) parameters['substring'] = options.substring
    if (options.number_type) parameters['number_type'] = options.number_type
    return this.withApiKey(async (apiKey) => {
      return standardGet<OptionalTwilioNumber[]>(
        buildUrl(this.hostname, TWILIO_NUMBERS),
        { api_key: apiKey, ...parameters }
      )
    })
  }

  async reassignTwilioNumberAdmin(repPhoneValue: string, releaseUserId: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, TWILIO_NUMBERS_ADMIN),
        { 
          api_key: apiKey, 
          phone_number: repPhoneValue, 
          reassign_user_id: releaseUserId 
        },
        { statusOnly: true }
      )
    })
  }

  async releaseTwilioNumberAdmin(repPhoneValue: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, TWILIO_NUMBERS_ADMIN),
        { api_key: apiKey, phone_number: repPhoneValue, release: true },
        { statusOnly: true }
      )
    })
  }

  async acquireTwilioNumberAdmin(repPhoneValue: string, targetUserId: string, countryIsoCode?: string, numberType?: 'Local' | 'Mobile' | 'TollFree'): Promise<RegisteredTwilioNumber | string> {
    const parameters: Record<string, any> = {
      'phone_number': repPhoneValue,
      'target_user_id': targetUserId
    }
    if (countryIsoCode) parameters['country'] = countryIsoCode
    if (numberType) parameters['number_type'] = numberType
    const result = await this.withApiKey(async (apiKey) => {
      const response = await standardPut<Response>(
        buildUrl(this.hostname, TWILIO_NUMBERS_ADMIN),
        { api_key: apiKey, ...parameters },
        { rawResponse: true }
      )
      if (!response) return `Failed to confirm purchase of ${repPhoneValue}.`
      return await this.registerNumberResponseToNumberOrError(response, repPhoneValue)
    })
    return result || `Failed to confirm purchase of ${repPhoneValue}.`
  }

  async registerTwilioNumberForTeam(repPhoneValue: string, countryIsoCode?: string, numberType?: 'Local' | 'Mobile' | 'TollFree'): Promise<RegisteredTwilioNumber | string> {
    if (!this.selectedTeamId) return "No team selected"
    const parameters: Record<string, any> = {
      'phone_number': repPhoneValue,
      'team_id': this.selectedTeamId
    }
    if (countryIsoCode) parameters['country'] = countryIsoCode
    if (numberType) parameters['number_type'] = numberType
    const result = await this.withApiKey(async (apiKey) => {
      const response = await standardPut<Response>(
        buildUrl(this.hostname, TWILIO_NUMBERS_ADMIN),
        { api_key: apiKey, ...parameters },
        { rawResponse: true }
      )
      if (!response) return `Failed to confirm purchase of ${repPhoneValue}.`
      return await this.registerNumberResponseToNumberOrError(response, repPhoneValue)
    })
    return result || `Failed to confirm purchase of ${repPhoneValue}.`
  }

  async getTwilioNumberForTeam(): Promise<RegisteredTwilioNumber[] | null> { 
    if (!this.selectedTeamId) return null 
    return this.withApiKey(async (apiKey) => {
      return standardGet<RegisteredTwilioNumber[]>(
        buildUrl(this.hostname, TWILIO_NUMBERS_ADMIN),
        { api_key: apiKey, team_id: this.selectedTeamId },
        {},
        jsonSafeToRegisteredTwilioNumbers
      )
    })
  }

  async releaseTwilioNumberForTeam(repPhoneValue: string): Promise<boolean | null> {
    if (!this.selectedTeamId) return false
    return this.withApiKey(async (apiKey) => {
      return standardPut<boolean>(
        buildUrl(this.hostname, TWILIO_NUMBERS_ADMIN),
        { api_key: apiKey, phone_number: repPhoneValue, team_id: this.selectedTeamId, release: true },
        { statusOnly: true }  
      )
    })
  }

  // ==================== STIRSHAKEN/VOICE INTEGRITY ====================

  async getCustomerProfileData(teamId: string): Promise<CustomerProfileData | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<CustomerProfileData>(
        buildUrl(this.hostname, SHAKEN_STIR),
        { api_key: apiKey, team_id: teamId },
        {},
        jsonSafeToCustomerProfileData
      )
    })
  }

  async getVoiceIntegrityStatus(teamId: string): Promise<VoiceIntegrityInfo | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<VoiceIntegrityInfo>(
        buildUrl(this.hostname, VOICE_INTEGRITY),
        { api_key: apiKey, team_id: teamId }
      )
    })
  }

  async updateVoiceIntegrityStatus(
    teamId: string, 
    useCase: VoiceIntegrityUseCase, 
    businessEmployeeCount: number, 
    averageBusinessDayCallVolume: number, 
    notes: string
  ): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      const response = await standardPost<Response>(
        buildUrl(this.hostname, VOICE_INTEGRITY),
        { 
          api_key: apiKey, 
          team_id: teamId, 
          use_case: useCase, 
          business_employee_count: businessEmployeeCount, 
          average_business_day_call_volume: averageBusinessDayCallVolume, 
          notes 
        },
        { noJsonification: true }
      )
      if (!response) return false
      return response.status === 200
    })
  }

  async submitStirShakenRegistration(payload: Record<string, any>): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      const response = await standardPost<Response>(
        buildUrl(this.hostname, SHAKEN_STIR),
        { api_key: apiKey, ...payload },
        { noJsonification: true }
      )
      if (!response) return false
      return response.status === 200
    })
  }

  // ==================== CNAM REGISTRATION ====================

  async getCnamRegistrations(teamId: string): Promise<CNAMRegistration[] | null> {
    return this.withApiKey(async (apiKey) => {
      const result = await standardGet<CNAMRegistration[]>(
        buildUrl(this.hostname, CNAM),
        { api_key: apiKey, team_id: teamId },
        {},
        (data: any[]) => data.map(item => jsonSafeToCNAMRegistration(item))
      )
      return result || []
    })
  }

  async postCnamRegistration(
    teamId: string,
    name: string,
    addPhoneNumbers?: string[],
    removePhoneNumbers?: string[]
  ): Promise<CNAMRegistration | null> {
    return this.withApiKey(async (apiKey) => {
      const params: Record<string, any> = {
        api_key: apiKey,
        team_id: teamId,
        name
      }
      
      if (addPhoneNumbers && addPhoneNumbers.length > 0) {
        params.add_phone_numbers = addPhoneNumbers
      }
      
      if (removePhoneNumbers && removePhoneNumbers.length > 0) {
        params.remove_phone_numbers = removePhoneNumbers
      }

      return standardPost<CNAMRegistration>(
        buildUrl(this.hostname, CNAM),
        params,
        {},
        jsonSafeToCNAMRegistration
      )
    })
  }

  // ==================== RECORDED GREETINGS ====================

  async uploadGreeting(name: string, file: File): Promise<RecordedGreeting | null> {
    return this.withApiKey(async (apiKey) => {
      const formData = new FormData()
      formData.append('api_key', apiKey)
      formData.append('name', name)
      formData.append('file', file)
      return standardPost<RecordedGreeting>(
        buildUrl(this.hostname, RECORDED_GREETINGS),
        formData,
      )
    })
  }

  async uploadGreetingFromURL(name: string, url: string): Promise<RecordedGreeting | null> {
    return this.withApiKey(async (apiKey) => {
      const formData = new FormData()
      formData.append('api_key', apiKey)
      formData.append('name', name)
      formData.append('url', url)
      return standardPost<RecordedGreeting>(
        buildUrl(this.hostname, RECORDED_GREETINGS),
        formData,
      )
    })
  }

  async getGreetings(): Promise<RecordedGreeting[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<RecordedGreeting[]>(
        buildUrl(this.hostname, RECORDED_GREETINGS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES }
      )
    })
  }

  async getSpecificGreetingURL(recordedGreetingId: string): Promise<string | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<string>(
        buildUrl(this.hostname, RECORDED_GREETINGS),
        { api_key: apiKey, recorded_greeting_id: recordedGreetingId }
      )
    })
  }

  async renameGreeting(recordedGreetingId: string, name: string): Promise<RecordedGreeting | null> {
    return this.withApiKey(async (apiKey) => {
      const formData = new FormData()
      formData.append('api_key', apiKey)
      formData.append('recorded_greeting_id', recordedGreetingId)
      formData.append('name', name)
      return standardPost<RecordedGreeting>(
        buildUrl(this.hostname, RECORDED_GREETINGS),
        formData,
      )
    })
  }

  async deleteGreeting(recordedGreetingId: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      const formData = new FormData()
      formData.append('api_key', apiKey)
      formData.append('recorded_greeting_id', recordedGreetingId)
      formData.append('delete', 'delete')
      return standardPost<boolean>(
        buildUrl(this.hostname, RECORDED_GREETINGS),
        formData,
      ) !== null
    })
  }

  // ==================== SALES ROOMS ====================

  async getSalesRooms(): Promise<SalesRoom[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<SalesRoom[]>(
        buildUrl(SALES_FLOOR_HOSTNAME, SALES_FLOOR_ROOMS),
        { api_key: apiKey },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES }
      )
    })
  }

  async removeSalesRoom(salesRoomId: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<boolean>(
        buildUrl(SALES_FLOOR_HOSTNAME, SALES_FLOOR_ROOMS),
        { api_key: apiKey, room_id: salesRoomId, delete: true }
      ) !== null
    })
  }

  async createSalesRoom(salesRoomName: string, personal: boolean = false): Promise<SalesRoom | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<SalesRoom>(
        buildUrl(SALES_FLOOR_HOSTNAME, SALES_FLOOR_ROOMS),
        { api_key: apiKey, room_name: salesRoomName, personal }
      )
    })
  }

  async updateSalesRoom(salesRoomId: string, salesRoomName: string): Promise<SalesRoom | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<SalesRoom>(
        buildUrl(SALES_FLOOR_HOSTNAME, SALES_FLOOR_ROOMS),
        { api_key: apiKey, room_id: salesRoomId, room_name: salesRoomName }
      )
    })
  }

  async adjustSalesRoomMembership(salesRoomId: string, action: 'join' | 'leave'): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<boolean>(
        buildUrl(SALES_FLOOR_HOSTNAME, SALES_FLOOR_ROOM_MEMBERS),
        { api_key: apiKey, room_id: salesRoomId, action }
      ) !== null
    })
  }

  // ==================== HELPER METHODS ====================

  async getVapiCall(apiKey: string, matchingCall: BotCall): Promise<Call | null> {
    try {
      const client = new VapiClient({ token: apiKey });
      const result = await client.calls.list({
        createdAtGt: matchingCall.start.toISOString(),
        createdAtLt: new Date(matchingCall.start.getTime() + 10*60*SEC_TO_MS).toISOString(),
      })
      if (!result || !result.length) return null
      const matching = result.find((c) => {
        if (!c.assistant?.metadata) return false
        return c.assistant?.metadata['bot_call_id'] === matchingCall.bot_call_id
      })
      if (!matching) return null
      return matching
    } catch (e) {
      return null
    }
  }

  async getVapiCallsBot(apiKey: string, botId: string): Promise<Call[] | null> {
    try {
      const client = new VapiClient({ token: apiKey });
      const result = await client.calls.list({
        assistantId: botId,
      })
      return result
    } catch (e) {
      return null
    }
  }


  async getSavedViews(): Promise<SavedView[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<SavedView[]>(
        buildUrl(this.hostname, SAVED_VIEWS),
        { api_key: apiKey },
        {},
        jsonSafeToSavedViewList
      )
    })
  }

  async addSavedView(name: string, is_team: boolean, filter: BackendFilter): Promise<SavedView | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<SavedView>(
        buildUrl(this.hostname, SAVED_VIEWS),
        { api_key: apiKey, name, is_team, filter_str: JSON.stringify(filter) },
        {},
        jsonSafeToSavedView
      )
    })
  }

  async updateSavedView(view: SavedView): Promise<SavedView | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPut<SavedView>(
        buildUrl(this.hostname, SAVED_VIEWS),
        { api_key: apiKey, view_id: view.view_id, name: view.name, is_team: view.is_team, filter_str: JSON.stringify(view.filter) },
        {},
        jsonSafeToSavedView
      )
    })
  }

  async deleteSavedView(view_id: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardDelete<boolean>(
        buildUrl(this.hostname, SAVED_VIEWS),
        { api_key: apiKey, view_id }
      ) !== null
    })
  }

  async getProvisionedTeams(): Promise<ProvisionedTeam[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<ProvisionedTeam[]>(
        buildUrl(this.hostname, API_PROVISIONED_TEAMS),
        { api_key: apiKey },
        {},
        jsonSafeToProvisionedTeams
      )
    })
  }

  async provisionNewTeam( team: string ): Promise<TeamResult | null> {
      return this.withApiKey(async (apiKey) => {
        return standardPost<TeamResult>(
          buildUrl(this.hostname, API_PROVISIONED_TEAMS),
          { 
            api_key: apiKey, 
            update: {
              team, 
              subscription_type: SubscriptionType.TEAM, 
              default_prospect_recording: PROSPECT_RECORDING_SETTING.ALL, 
              default_prospect_streaming_transcription: PROSPECT_RECORDING_SETTING.ALL, 
              default_prospect_transcript_persistence: PROSPECT_RECORDING_SETTING.ALL, 
              default_language: DEFAULT_LANGUAGE_SETTING.ENGLISH, 
            }
          }
        )
      })
  }

  async updateProvisionTeam( team_id: string, team_name: string ): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<boolean>(
        buildUrl(this.hostname, API_PROVISIONED_TEAMS),
        { api_key: apiKey, update: {team_id, team:team_name } }
      )
    })
  }

  async getInboundRoutes(): Promise<InboundRoute[] | null> {
    if (!this.selectedTeamId) return null 
    return this.withApiKey(async (apiKey) => {
      return standardGet<InboundRoute[]>(
        buildUrl(this.hostname, API_INBOUND_ROUTES),
        { api_key: apiKey, team_id: this.selectedTeamId }
      )
    })  
  }

  async addRoute(routeData: Partial<InboundRoute>): Promise<InboundRoute | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      // Prepare route data with defaults for undefined fields
      const processedRouteData = {
        ...routeData,
        // Set forwarded_from to '_ALL_' if not provided
        forwarded_from: routeData.forwarded_from ?? '_ALL_'
      }

      return standardPost<InboundRoute>(
        buildUrl(this.hostname, API_INBOUND_ROUTES),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          update: processedRouteData
        }
      )
    })
  }

  async updateRoute(routeId: string, routeData: Partial<InboundRoute>): Promise<boolean | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_INBOUND_ROUTES),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          route_id: routeId,
          update: routeData
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
  }

  async deleteRoute(routeId: string): Promise<boolean | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_INBOUND_ROUTES),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          route_id: routeId,
          delete: true
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
  }

  // ==================== PAYLOAD MANAGEMENT METHODS ====================

  async getSessionWebhooks(): Promise<SessionWebhooksResponse | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const result = await standardGet<SessionWebhooksResponse>(
        buildUrl(this.hostname, API_SESSION_WEBHOOKS),
        { api_key: apiKey, team_id: this.selectedTeamId }
      )
      
      // Convert actual newlines back to __newline__ tokens for UI display
      if (result && result.payloads) {
        result.payloads = result.payloads.map(payload => ({
          ...payload,
          value_rule_str: payload.value_rule_str.replace(new RegExp('"' + String.fromCharCode(10) + '"', 'g'), '__newline__')
        }))
      }
      
      return result
    })
  }

  async getStateFields(): Promise<StateFieldsResponse | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      return standardGet<StateFieldsResponse>(
        buildUrl(this.hostname, API_STATE_FIELDS),
        { api_key: apiKey, team_id: this.selectedTeamId }
      )
    })
  }

  async createStateCollection(data: CreateStateCollectionRequest): Promise<StateCollection | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const cleanedData = { ...data }
      if (cleanedData.fields) {
        cleanedData.fields = cleanedData.fields.map(field => {
          const cleanField: any = {
            field_name: field.field_name,
            field_type: field.field_type,
          }
          // Only include non-empty optional fields
          if (field.description && field.description.trim()) {
            cleanField.description = field.description
          }
          if (field.default_json_str && field.default_json_str.trim()) {
            cleanField.default_json_str = field.default_json_str
          }
          if (field.derivation_rule && field.derivation_rule.trim()) {
            cleanField.derivation_rule = field.derivation_rule
          }
          if (field.choices_json_str && field.choices_json_str.trim()) {
            cleanField.choices_json_str = field.choices_json_str
          }
          if (field.choices_field_name && field.choices_field_name.trim()) {
            cleanField.choices_field_name = field.choices_field_name
          }
          if (field.int_min_value !== undefined) {
            cleanField.int_min_value = field.int_min_value
          }
          if (field.int_max_value !== undefined) {
            cleanField.int_max_value = field.int_max_value
          }
          return cleanField
        })
      }
      const result = await standardPostWithErrorHandling<any>(
        buildUrl(this.hostname, API_STATE_FIELDS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          update: cleanedData
        },
      )
      
      // Check if result is an error from the backend
      if (!result.success) {
        return result.error_message // Return the error message
      }
      
      return result.value
    })
  }

  async updateStateCollection(stateId: string, data: UpdateStateCollectionRequest): Promise<StateCollection | null> {
    if (!this.selectedTeamId) return null
    
    try {
      const result = await this.withApiKey(async (apiKey) => {
        const cleanedData = { ...data }
        if (cleanedData.fields) {
          cleanedData.fields = cleanedData.fields.map(field => {
            const cleanField: any = {
              field_name: field.field_name,
              field_type: field.field_type,
            }
            // Only include non-empty optional fields
            if (field.description && field.description.trim()) {
              cleanField.description = field.description
            }
            if (field.default_json_str && field.default_json_str.trim()) {
              cleanField.default_json_str = field.default_json_str
            }
            if (field.derivation_rule && field.derivation_rule.trim()) {
              cleanField.derivation_rule = field.derivation_rule
            }
            if (field.choices_json_str && field.choices_json_str.trim()) {
              cleanField.choices_json_str = field.choices_json_str
            }
            if (field.choices_field_name && field.choices_field_name.trim()) {
              cleanField.choices_field_name = field.choices_field_name
            }
            if (field.int_min_value !== undefined) {
              cleanField.int_min_value = field.int_min_value
            }
            if (field.int_max_value !== undefined) {
              cleanField.int_max_value = field.int_max_value
            }
            return cleanField
          })
        }
        const result = await standardPostWithErrorHandling<any>(
          buildUrl(this.hostname, API_STATE_FIELDS),
          { 
            api_key: apiKey, 
            team_id: this.selectedTeamId,
            state_id: stateId,
            update: cleanedData
          },
          { textResponse: true }
        )
        
        // Check if result is an error from the backend
        if (!result.success) {
          throw new Error(result.error_message || 'Failed to update state collection')
        }
        
        // For successful updates, return a StateCollection object
        // Since the API doesn't return the updated collection, we construct one with the updated name
        return {
          state_id: stateId,
          team_id: this.selectedTeamId,
          name: cleanedData.name || 'Updated Collection'
        } as StateCollection
      })
      
      return result
    } catch (error) {
      console.error('Error updating state collection:', error)
      return null
    }
  }

  async deleteStateCollection(stateId: string): Promise<boolean> {
    if (!this.selectedTeamId) return false
    const result = await this.withApiKey(async (apiKey) => {
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_STATE_FIELDS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          state_id: stateId,
          delete: true
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
    return result || false
  }


  // Bulk update all state fields for a state collection
  async bulkUpdateStateFields(stateId: string, fields: StateField[], collectionName: string, isNewCollection = false): Promise<ServiceResult<StateField[]>> {
    if (!this.selectedTeamId) {
      return { success: false, value: null, error_message: 'No team selected' }
    }
    
    return this.withApiKeyServiceResult(async (apiKey) => {
      // Clean all fields - remove empty optional properties
      const cleanFields = fields.map((field: StateField) => {
        const cleanField: Partial<StateField> = {
          field_name: field.field_name,
          field_type: field.field_type,
        }
        
        // Only include non-empty optional fields
        if (field.description && field.description.trim()) {
          cleanField.description = field.description
        }
        if (field.default_json_str && field.default_json_str.trim()) {
          cleanField.default_json_str = field.default_json_str
        }
        if (field.derivation_rule && field.derivation_rule.trim()) {
          cleanField.derivation_rule = field.derivation_rule
        }
        if (field.choices_json_str && field.choices_json_str.trim()) {
          cleanField.choices_json_str = field.choices_json_str
        }
        if (field.choices_field_name && field.choices_field_name.trim()) {
          cleanField.choices_field_name = field.choices_field_name
        }
        if (field.int_min_value !== undefined && field.int_min_value !== null) {
          cleanField.int_min_value = field.int_min_value
        }
        if (field.int_max_value !== undefined && field.int_max_value !== null) {
          cleanField.int_max_value = field.int_max_value
        }
        if (field.may_interject !== undefined && field.may_interject !== null) {
          cleanField.may_interject = field.may_interject
        }
        if (field.may_continue_interjections && field.may_continue_interjections.trim()) {
          cleanField.may_continue_interjections = field.may_continue_interjections
        }
        
        return cleanField
      })

      interface BulkUpdateRequest {
        api_key: string
        team_id: string
        state_id?: string // Optional for new collections
        update: {
          name: string
          fields: Partial<StateField>[]
        }
      }

      const requestBody: BulkUpdateRequest = {
        api_key: apiKey,
        team_id: this.selectedTeamId!,
        update: {
          name: collectionName,
          fields: cleanFields
        }
      }

      // Only include state_id for existing collections
      if (!isNewCollection) {
        requestBody.state_id = stateId
      }

      console.log('Bulk update state fields request:', requestBody)
      
      const result = await standardPostWithErrorHandling<any>(
        buildUrl(this.hostname, API_STATE_FIELDS),
        requestBody,
        { textResponse: true }
      )
      
      // Return the structured result
      if (!result.success) {
        console.error('[Services] Bulk update failed with error:', result.error_message)
        return { success: false, value: null, error_message: result.error_message || 'Failed to update state fields' }
      }
      
      console.log('[Services] Bulk update successful, returning fields')
      return { success: true, value: fields, error_message: null }
    })
  }

  async createSessionWebhook(data: { url: string, http_verb: string, encoding?: string, notify_not_ok?: boolean, registries?: SessionWebhookRegistry[], payloads?: SessionWebhookPayload[] }): Promise<any> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const cleanedData = { ...data }
      if (cleanedData.registries) {
        cleanedData.registries = cleanedData.registries.filter(r => r.route_id || r.event || r.requirement_rule)
      }
      if (cleanedData.payloads) {
        cleanedData.payloads = cleanedData.payloads
          .filter(p => p.key && p.parameter_type && p.value_rule_str)
          .map(p => ({ ...p, value_rule_str: p.value_rule_str.replace(/__newline__/g, '"' + String.fromCharCode(10) + '"') }))
      }
      return standardPost<any>(
        buildUrl(this.hostname, API_SESSION_WEBHOOKS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          update: cleanedData
        }
      )
    })
  }

  async updateSessionWebhook(webhookId: string, data: { url?: string, http_verb?: string, encoding?: string, notify_not_ok?: boolean, registries?: SessionWebhookRegistry[], payloads?: SessionWebhookPayload[] }): Promise<any> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const cleanedData = { ...data }
      if (cleanedData.registries) {
        cleanedData.registries = cleanedData.registries.filter(r => r.route_id || r.event || r.requirement_rule)
      }
      if (cleanedData.payloads) {
        cleanedData.payloads = cleanedData.payloads
          .filter(p => p.key && p.parameter_type && p.value_rule_str)
          .map(p => ({ ...p, value_rule_str: p.value_rule_str.replace(/__newline__/g, '"' + String.fromCharCode(10) + '"') }))
      }
      return standardPost<any>(
        buildUrl(this.hostname, API_SESSION_WEBHOOKS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          webhook_id: webhookId,
          update: cleanedData
        }
      )
    })
  }

  async deleteSessionWebhook(webhookId: string): Promise<boolean> {
    if (!this.selectedTeamId) return false
    const result = await this.withApiKey(async (apiKey) => {
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_SESSION_WEBHOOKS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          webhook_id: webhookId,
          delete: true
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
    return result || false
  }

  async createWebhookPayload(webhookId: string, payload: SessionWebhookPayload): Promise<SessionWebhookPayload | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      // Get current webhook data to preserve existing payloads
      const currentWebhooks = await this.getSessionWebhooks()
      if (!currentWebhooks) return null
      
      const existingPayloads = currentWebhooks.payloads.filter(p => p.webhook_id === webhookId)
      const existingRegistries = currentWebhooks.registries.filter(r => r.webhook_id === webhookId)
      
      // Create new payload data (backend will add team_id and webhook_id)
      const newPayload = {
        parameter_type: payload.parameter_type,
        key: payload.key,
        value_rule_str: payload.value_rule_str.replace(/__newline__/g, '"' + String.fromCharCode(10) + '"'),
        formatter: payload.formatter || undefined
      }
      
      // Prepare all payloads (existing + new)
      const allPayloads = [
        ...existingPayloads.map(p => ({
          parameter_type: p.parameter_type,
          key: p.key,
          value_rule_str: p.value_rule_str.replace(/__newline__/g, '"' + String.fromCharCode(10) + '"'),
          formatter: p.formatter || undefined
        })),
        newPayload
      ]
      
      // Prepare registries to preserve them
      const allRegistries = existingRegistries.map(r => ({
        route_id: r.route_id || undefined,
        event: r.event,
        requirement_rule: r.requirement_rule || undefined
      }))
      
      await standardPost<any>(
        buildUrl(this.hostname, API_SESSION_WEBHOOKS),
        {
          api_key: apiKey,
          team_id: this.selectedTeamId,
          webhook_id: webhookId,
          update: {
            payloads: allPayloads,
            registries: allRegistries
          }
        }
      )
      
      // Return the payload with proper IDs for Redux store, converting newlines back to tokens
      return {
        ...newPayload,
        value_rule_str: newPayload.value_rule_str.replace(new RegExp('"' + String.fromCharCode(10) + '"', 'g'), '__newline__'),
        webhook_id: webhookId,
        team_id: this.selectedTeamId!
      }
    })
  }

  async updateWebhookPayload(webhookId: string, payloadKey: string, payload: SessionWebhookPayload): Promise<SessionWebhookPayload | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      // Get current webhook data to preserve other payloads
      const currentWebhooks = await this.getSessionWebhooks()
      if (!currentWebhooks) return null
      
      const existingPayloads = currentWebhooks.payloads.filter(p => p.webhook_id === webhookId)
      const existingRegistries = currentWebhooks.registries.filter(r => r.webhook_id === webhookId)
      
      // Update the specific payload while preserving others
      const updatedPayloads = existingPayloads.map(p => {
        if (p.key === payloadKey) {
          return {
            parameter_type: payload.parameter_type,
            key: payload.key,
            value_rule_str: payload.value_rule_str.replace(/__newline__/g, '"' + String.fromCharCode(10) + '"'),
            formatter: payload.formatter || undefined
          }
        } else {
          return {
            parameter_type: p.parameter_type,
            key: p.key,
            value_rule_str: p.value_rule_str.replace(/__newline__/g, '"' + String.fromCharCode(10) + '"'),
            formatter: p.formatter || undefined
          }
        }
      })
      
      // Prepare registries to preserve them
      const allRegistries = existingRegistries.map(r => ({
        route_id: r.route_id || undefined,
        event: r.event,
        requirement_rule: r.requirement_rule || undefined
      }))
      
      await standardPost<any>(
        buildUrl(this.hostname, API_SESSION_WEBHOOKS),
        {
          api_key: apiKey,
          team_id: this.selectedTeamId,
          webhook_id: webhookId,
          update: {
            payloads: updatedPayloads,
            registries: allRegistries
          }
        }
      )
      
      // Return the updated payload with proper IDs for Redux store, converting newlines back to tokens
      return {
        parameter_type: payload.parameter_type,
        key: payload.key,
        value_rule_str: payload.value_rule_str.replace(new RegExp('"' + String.fromCharCode(10) + '"', 'g'), '__newline__'),
        formatter: payload.formatter || undefined,
        webhook_id: webhookId,
        team_id: this.selectedTeamId!
      }
    })
  }

  async deleteWebhookPayload(webhookId: string, payloadKey: string): Promise<boolean> {
    if (!this.selectedTeamId) return false
    const result = await this.withApiKey(async (apiKey) => {
      // Get current webhook data and remove the specific payload
      const currentWebhooks = await this.getSessionWebhooks()
      if (!currentWebhooks) return false
      
      const webhook = currentWebhooks.webhooks.find(w => w.webhook_id === webhookId)
      if (!webhook) return false
      
      const filteredPayloads = currentWebhooks.payloads
        .filter(p => p.webhook_id === webhookId && !(p.key === payloadKey))
        .map(p => ({
          parameter_type: p.parameter_type,
          key: p.key,
          value_rule_str: p.value_rule_str.replace(/__newline__/g, '"' + String.fromCharCode(10) + '"'),
          formatter: p.formatter || undefined
        }))
      
      const existingRegistries = currentWebhooks.registries
        .filter(r => r.webhook_id === webhookId)
        .map(r => ({
          route_id: r.route_id || undefined,
          event: r.event,
          requirement_rule: r.requirement_rule || undefined
        }))
      
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_SESSION_WEBHOOKS),
        {
          api_key: apiKey,
          team_id: this.selectedTeamId,
          webhook_id: webhookId,
          update: {
            url: webhook.url,
            http_verb: webhook.http_verb,
            encoding: webhook.encoding,
            notify_not_ok: webhook.notify_not_ok,
            payloads: filteredPayloads,
            registries: existingRegistries
          }
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
    return result || false
  }

  async createWebhookRegistry(webhookId: string, registry: SessionWebhookRegistry): Promise<SessionWebhookRegistry | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      // Get current webhook data and add the new registry
      const currentWebhooks = await this.getSessionWebhooks()
      if (!currentWebhooks) return null
      
      const webhook = currentWebhooks.webhooks.find(w => w.webhook_id === webhookId)
      if (!webhook) return null
      
      const existingRegistries = currentWebhooks.registries
        .filter(r => r.webhook_id === webhookId)
        .map(r => ({
          route_id: r.route_id,
          event: r.event,
          requirement_rule: r.requirement_rule
        }))
      
      const newRegistry = {
        route_id: registry.route_id,
        event: registry.event,
        requirement_rule: registry.requirement_rule
      }
      
      const result = await standardPost<any>(
        buildUrl(this.hostname, API_SESSION_WEBHOOKS),
        {
          api_key: apiKey,
          team_id: this.selectedTeamId,
          webhook_id: webhookId,
          update: {
            url: webhook.url,
            http_verb: webhook.http_verb,
            encoding: webhook.encoding,
            notify_not_ok: webhook.notify_not_ok,
            payloads: currentWebhooks.payloads.filter(p => p.webhook_id === webhookId),
            registries: [...existingRegistries, newRegistry]
          }
        }
      )
      
      // The backend should return the complete updated webhook data including registries
      // Extract the newly created registry from the response
      if (result && result.registries) {
        // Find the registry that matches our input and return it with the backend-generated ID
        const createdRegistry = result.registries.find((r: any) => 
          r.webhook_id === webhookId && 
          r.route_id === newRegistry.route_id &&
          r.event === newRegistry.event &&
          r.requirement_rule === newRegistry.requirement_rule
        )
        return createdRegistry
      }
      
      // Fallback: construct with generated ID
      return {
        registry_id: `registry_${Date.now()}`,
        webhook_id: webhookId,
        team_id: this.selectedTeamId,
        route_id: newRegistry.route_id || null,
        event: newRegistry.event,
        requirement_rule: newRegistry.requirement_rule || null
      }
    })
  }

  async updateWebhookRegistry(webhookId: string, registryId: string, registry: any): Promise<any> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      // Get current webhook data and update the specific registry
      const currentWebhooks = await this.getSessionWebhooks()
      if (!currentWebhooks) return null
      
      const webhook = currentWebhooks.webhooks.find(w => w.webhook_id === webhookId)
      if (!webhook) return null
      
      const updatedRegistries = currentWebhooks.registries
        .filter(r => r.webhook_id === webhookId)
        .map(r => {
          if (r.registry_id === registryId) {
            return {
              route_id: registry.route_id,
              event: registry.event,
              requirement_rule: registry.requirement_rule
            }
          } else {
            return {
              route_id: r.route_id,
              event: r.event,
              requirement_rule: r.requirement_rule
            }
          }
        })
      
      const result = await standardPost<any>(
        buildUrl(this.hostname, API_SESSION_WEBHOOKS),
        {
          api_key: apiKey,
          team_id: this.selectedTeamId,
          webhook_id: webhookId,
          update: {
            url: webhook.url,
            http_verb: webhook.http_verb,
            encoding: webhook.encoding,
            notify_not_ok: webhook.notify_not_ok,
            payloads: currentWebhooks.payloads.filter(p => p.webhook_id === webhookId),
            registries: updatedRegistries
          }
        }
      )
      return result
    })
  }

  async deleteWebhookRegistry(webhookId: string, registryId: string): Promise<boolean> {
    if (!this.selectedTeamId) return false
    const result = await this.withApiKey(async (apiKey) => {
      // Get current webhook data and remove the specific registry
      const currentWebhooks = await this.getSessionWebhooks()
      if (!currentWebhooks) return false
      
      const webhook = currentWebhooks.webhooks.find(w => w.webhook_id === webhookId)
      if (!webhook) return false
      
      const filteredRegistries = currentWebhooks.registries
        .filter(r => r.webhook_id === webhookId && r.registry_id !== registryId)
        .map(r => ({
          route_id: r.route_id,
          event: r.event,
          requirement_rule: r.requirement_rule
        }))
      
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_SESSION_WEBHOOKS),
        {
          api_key: apiKey,
          team_id: this.selectedTeamId,
          webhook_id: webhookId,
          update: {
            url: webhook.url,
            http_verb: webhook.http_verb,
            encoding: webhook.encoding,
            notify_not_ok: webhook.notify_not_ok,
            payloads: currentWebhooks.payloads.filter(p => p.webhook_id === webhookId),
            registries: filteredRegistries
          }
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
    return result || false
  }

  async getMegaComposer(): Promise<MegaPromptComposer[] | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      return standardGet<MegaPromptComposer[]>(
        buildUrl(this.hostname, API_MEGA_COMPOSERS),
        { api_key: apiKey, team_id: this.selectedTeamId },
        {},
        jsonToMegaPromptComposers
      )
    })
  }

  async addMegaComposer(composer: Partial<MegaPromptComposer>): Promise<MegaPromptComposer | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      return standardPost<MegaPromptComposer>(
        buildUrl(this.hostname, API_MEGA_COMPOSERS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          update: composer
        },
        {},
        jsonToMegaPromptComposer
      )
    })
  }

  async updateMegaComposer(composerId: string, update: Partial<MegaPromptComposer>): Promise<boolean | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_MEGA_COMPOSERS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          composer_id: composerId,
          update
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
  }

  async deleteMegaComposer(composerId: string): Promise<boolean | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_MEGA_COMPOSERS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          composer_id: composerId,
          delete: true
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
  }


  // Split Composers
  async getSplitComposers(): Promise<SplitComposersResponse | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const result = await standardGet<any>(
        buildUrl(this.hostname, API_SPLIT_COMPOSERS),
        { api_key: apiKey, team_id: this.selectedTeamId },
        {}
      )
      
      if (!result) return null
      
      return {
        composers: jsonToSplitComposers(result.composers || []),
        goals: jsonToSplitGoals(result.goals || [])
      }
    })
  }

  async createSplitComposer(data: { composer_name: string, state_id: string, created_at?: number, goals?: any[] }): Promise<SplitComposer | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const result = await standardPost<any>(
        buildUrl(this.hostname, API_SPLIT_COMPOSERS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          update: data
        },
        {}
      )
      
      return result ? jsonToSplitComposer(result) : null
    })
  }

  async updateSplitComposer(composerId: string, data: { composer_name?: string, state_id?: string, goals?: any[] }): Promise<boolean | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_SPLIT_COMPOSERS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          composer_id: composerId,
          update: data
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
  }

  async deleteSplitComposer(composerId: string): Promise<boolean | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_SPLIT_COMPOSERS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          composer_id: composerId,
          delete: true
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
  }

  async getVoiceBots(): Promise<VoiceBot[] | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      return standardGet<VoiceBot[]>(
        buildUrl(this.hostname, API_VOICE_BOTS),
        { api_key: apiKey, team_id: this.selectedTeamId },
        {},
        jsonToVoiceBots
      )
    })
  }

  async addVoiceBot(bot: Partial<VoiceBot>): Promise<VoiceBot | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      // Convert JSON objects to strings for backend API
      const apiData = {
        ...bot,
        // Convert JSON fields to strings for API (or null if not provided)
        substitution_json_str: bot.substitution_json ? JSON.stringify(bot.substitution_json) : null,
        transfer_json_str: bot.transfer_json ? JSON.stringify(bot.transfer_json) : null
      }
      
      // Remove the original JSON fields since we're sending the string versions
      delete apiData.substitution_json
      delete apiData.transfer_json

      return standardPost<VoiceBot>(
        buildUrl(this.hostname, API_VOICE_BOTS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          update: apiData
        },
        {},
        jsonToVoiceBot
      )
    })
  }

  async updateVoiceBot(agentId: string, update: Partial<VoiceBot>): Promise<boolean | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      // Convert JSON objects to strings for backend API
      const apiData = {
        ...update,
        // Convert JSON fields to strings for API (or null if not provided)
        substitution_json_str: update.substitution_json ? JSON.stringify(update.substitution_json) : null,
        transfer_json_str: update.transfer_json ? JSON.stringify(update.transfer_json) : null
      }
      
      // Remove the original JSON fields since we're sending the string versions
      delete apiData.substitution_json
      delete apiData.transfer_json

      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_VOICE_BOTS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          agent_id: agentId,
          update: apiData
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
  }

  async deleteVoiceBot(agentId: string): Promise<boolean | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_VOICE_BOTS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          agent_id: agentId,
          delete: true
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
  }

  async getChatBots(): Promise<ChatBot[] | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      return standardGet<ChatBot[]>(
        buildUrl(this.hostname, API_CHAT_BOTS),
        { api_key: apiKey, team_id: this.selectedTeamId },
        { cacheable: true, cacheTimeMs: CACHE_5_MINUTES },
        jsonToChatBots
      )
    })
  }

  async addChatBot(bot: Partial<ChatBot>): Promise<ChatBot | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      // Convert JSON objects to strings for backend API
      const apiData = {
        ...bot,
        // Convert JSON field to string for API (ChatBots only have substitution_json, not transfer_json)
        substitution_json_str: bot.substitution_json ? JSON.stringify(bot.substitution_json) : null
      }
      
      // Remove the original JSON field since we're sending the string version
      delete apiData.substitution_json

      return standardPost<ChatBot>(
        buildUrl(this.hostname, API_CHAT_BOTS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          update: apiData
        },
        {},
        (data: any) => data // ChatBot objects should be returned as-is from the API
      )
    })
  }

  async updateChatBot(agentId: string, update: Partial<ChatBot>): Promise<boolean | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      // Convert JSON objects to strings for backend API
      const apiData = {
        ...update,
        // Convert JSON field to string for API (ChatBots only have substitution_json, not transfer_json)
        substitution_json_str: update.substitution_json ? JSON.stringify(update.substitution_json) : null
      }
      
      // Remove the original JSON field since we're sending the string version
      delete apiData.substitution_json

      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_CHAT_BOTS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          agent_id: agentId,
          update: apiData
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
  }

  async deleteChatBot(agentId: string): Promise<boolean | null> {
    if (!this.selectedTeamId) return null
    return this.withApiKey(async (apiKey) => {
      const result = await standardPost<Response>(
        buildUrl(this.hostname, API_CHAT_BOTS),
        { 
          api_key: apiKey, 
          team_id: this.selectedTeamId,
          agent_id: agentId,
          delete: true
        },
        { noJsonification: true }
      )
      return result?.status === 200
    })
  }


  async provisionNewTeamWithTwilio(team: string, options: {
    weeklySpendLimit?: number,
    maxPhoneNumbersPerUser?: number,
    internationalEnabled?: boolean
  } = {}): Promise<TeamResult | null> {
    return this.withApiKey(async (apiKey) => {
      // First create the team
      const newTeam = await this.provisionNewTeam(team)
      if (!newTeam) {
        return null
      }

      // Wait 500ms to prevent race conditions
      await new Promise(resolve => setTimeout(resolve, 500))

      // Set default values - more generous defaults for new teams
      const weeklySpendLimit = options.weeklySpendLimit ?? 1000
      const maxPhoneNumbersPerUser = options.maxPhoneNumbersPerUser ?? 10
      const internationalEnabled = options.internationalEnabled ?? true

      try {
        // Create Twilio subscription with default quotas
        const quotasUpdate: ParallelDialerQuotasUpdate = {
          max_dials_at_once: 5,
          max_dials_per_second: 5,
          max_dials_per_month: 10000,
          max_phone_numbers_per_user: maxPhoneNumbersPerUser,
          international_credits_per_month: internationalEnabled ? (weeklySpendLimit * 4) : 0,
        }

        const subscriptionSuccess = await this.admin_updateParallelDialerQuotas(newTeam.team_id, quotasUpdate)
        
        if (!subscriptionSuccess) {
          console.warn('Failed to create Twilio subscription for new team')
        }

        // Return the team as-is since twilio_weekly_spend is handled by the subscription
        return newTeam
      } catch (error) {
        console.error('Error setting up Twilio subscription for new team:', error)
        // Return the team even if Twilio setup fails
        return newTeam
      }
    })
  }

  // ==================== FORWARDING NUMBER MANAGEMENT ====================

  async updateForwardingNumber(number: string | null): Promise<boolean | null> {
    const update: SettingsUpdate = {
      is_team: false,
      forwarding_number: number
    }
    return this.postSettings(update)
  }

  async updateForwardingNumberForUser(number: string | null, user_id: string): Promise<boolean | null> {
    const update: SettingsUpdate = {
      is_team: false,
      targeted_user_id: user_id,
      forwarding_number: number
    }
    return this.postSettings(update)
  }

  // ==================== INTERVIEW PORTAL SERVICES ====================

  async getInterviewPortalInfo(portalId: string): Promise<InterviewPortalInfo | null> {
    return standardGet<InterviewPortalInfo>(
      buildUrl(this.hostname, INTERVIEW_PORTAL_LINK_INFO),
      { portal_id: portalId },
      { cacheable: true, cacheTimeMs: CACHE_10_MINUTES },
      jsonSafeToInterviewPortalInfo
    )
  }

  async getInterviewPortalBots(portalId: string): Promise<InterviewBot[] | null> {
    return standardGet<InterviewBot[]>(
      buildUrl(this.hostname, INTERVIEW_PORTAL_BOTS),
      { portal_id: portalId },
      { cacheable: true, cacheTimeMs: CACHE_10_MINUTES },
      jsonSafeToInterviewBots
    )
  }

  async getInterviewBotCalls(portalId: string, userEmail: string, password: string): Promise<InterviewBotCall[] | null> {
    return standardGet<InterviewBotCall[]>(
      buildUrl(this.hostname, INTERVIEW_BOT_CALLS),
      { portal_id: portalId, user_email: userEmail, password: password },
      { cacheable: false },
      jsonSafeToInterviewBotCalls
    )
  }

  async createInterviewBotCall(request: CreateInterviewBotCallRequest): Promise<CreateInterviewBotCallResponse | null> {
    return standardPost<CreateInterviewBotCallResponse>(
      buildUrl(this.hostname, INTERVIEW_BOT_CALL),
      request,
      {},
      (data: any) => data as CreateInterviewBotCallResponse
    )
  }

  // ==================== INTERVIEW PORTAL ADMIN SERVICES ====================

  async getInterviewPortalCalls(portalId: string): Promise<InterviewBotCall[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<InterviewBotCall[]>(
        buildUrl(this.hostname, INTERVIEW_BOT_CALLS_ADMIN),
        { api_key: apiKey, portal_id: portalId },
        { cacheable: false },
        (data: InterviewBotCall[]) => {
          if (!Array.isArray(data)) {
            return []
          }
          return data.map(jsonSafeToInterviewBotCall)
        }
      )
    })
  }

  async getInterviewPortalCallsFiltered(params: { portalId: string; userEmails?: string[] | null; start?: Date | null; end?: Date | null }): Promise<InterviewBotCall[] | null> {
    const { portalId, userEmails, start, end } = params
    return this.withApiKey(async (apiKey) => {
      const extraHeaders: Record<string, any> = { api_key: apiKey, portal_id: portalId }
      if (userEmails && userEmails.length > 0) {
        extraHeaders['user_emails'] = userEmails
      }
      if (start) extraHeaders['start'] = start.getTime() * MS_TO_MICRO
      if (end) extraHeaders['end'] = end.getTime() * MS_TO_MICRO
      return standardGet<InterviewBotCall[]>(
        buildUrl(this.hostname, INTERVIEW_BOT_CALLS_ADMIN),
        extraHeaders,
        { cacheable: false },
        (data: InterviewBotCall[]) => {
          if (!Array.isArray(data)) return []
          return data.map(jsonSafeToInterviewBotCall)
        }
      )
    })
  }

  async getInterviewPortalUsers(portalId: string): Promise<InterviewPortalUser[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<InterviewPortalUser[]>(
        buildUrl(this.hostname, INTERVIEW_PORTAL_USERS),
        { api_key: apiKey, portal_id: portalId },
        { cacheable: false },
        (data: InterviewPortalUser[]) => {
          if (!Array.isArray(data)) {
            return []
          }
          return data.map(jsonSafeToInterviewPortalUser)
        }
      )
    })
  }

  async getInterviewPortalLinks(): Promise<InterviewPortalInfo[] | null> {
    return this.withApiKey(async (apiKey) => {
      return standardGet<InterviewPortalInfo[]>(
        buildUrl(this.hostname, INTERVIEW_PORTAL_LINKS),
        { api_key: apiKey },
        { cacheable: false },
        (data: InterviewPortalInfo[]) => {
          if (!Array.isArray(data)) {
            return []
          }
          return data.map(jsonSafeToInterviewPortalInfo)
        }
      )
    })
  }

  async createInterviewPortal(request: CreateInterviewPortalRequest): Promise<InterviewPortalInfo | null> {
    return this.withApiKey(async (apiKey) => {
      return standardPost<InterviewPortalInfo>(
        buildUrl(this.hostname, INTERVIEW_PORTAL_LINKS),
        { ...request, api_key: apiKey, team_id: this.selectedTeamId },
        {},
        jsonSafeToInterviewPortalInfo
      )
    })
  }

  async updateInterviewPortal(portalId: string, request: UpdateInterviewPortalRequest): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      const response = await corsPut(
        buildUrl(this.hostname, INTERVIEW_PORTAL_LINKS),
        { ...request, api_key: apiKey, portal_id: portalId }
      )
      
      if (response.status === 200) {
        return true
      }
      
      return false
    })
  }

  async deleteInterviewPortal(portalId: string): Promise<boolean | null> {
    return this.withApiKey(async (apiKey) => {
      const response = await corsDelete(
        buildUrl(this.hostname, INTERVIEW_PORTAL_LINKS),
        { api_key: apiKey, portal_id: portalId }
      )
      
      if (response.status === 200) {
        return true
      }
      
      return false
    })
  }
}

// ==================== SINGLETON INSTANCE ====================

let servicesManagerInstance: ServicesManager | null = null
export function getServicesManager(): ServicesManager {
  if (!servicesManagerInstance) {
    servicesManagerInstance = new ServicesManager()
  }
  return servicesManagerInstance
}

// Export the cache for external access if needed
export { serviceCache }
